(function () {
    'use strict';

    var shell = angular.module('app.shell', ['ui.router.metatags']);

    shell.run(['externalAuthSvc', 'appStatusSvc', 'restoreUserSvc', 'ngDialog', '$timeout', 'userSvc', '$rootScope', '$window', '$translate', '$state', 'userview_factory', 'endeksService', 'bolgeselDataService', '$ocLazyLoad', '$http', 'appSettingsSvc', '$transitions', '$interval', 'valuationGETAPI', 'alertAPI', 'notificationService', 'auth_factory', 'user_factory', 'CacheFactory', 'notifierSvc', 'comparablesApi', '$cookies',
        'orders_factory', 'mcpService',
        function (externalAuthSvc, appStatusSvc, restoreUserSvc, ngDialog, $timeout, userSvc, $rootScope, $window, $translate, $state, userview_factory, endeksService, bolgeselDataService, $ocLazyLoad, $http, appSettingsSvc, $transitions, $interval, valuationGETAPI, alertAPI, notificationService, auth_factory, user_factory, CacheFactory, notifierSvc, comparablesApi, $cookies, orders_factory, mcpService) {

            // Save HangiKredi campaign to rootScope flag
            if (sessionStorage.getItem('utm_campaign_hangi_kredi') === 'HangiKrediEndeksa50') {
                $rootScope.isHangiKrediCampaign = true;
            }

            externalAuthSvc.handleAuthResponse().then(
                function () {
                    return appStatusSvc.isReady(true);
                },
                function () {
                    restoreUserSvc.restore()['finally'](
                        function () {
                            return appStatusSvc.isReady(true);
                        });
                });

            $rootScope.SignedIn = userSvc.info.SignedIn;

            // Check if this is an MCP OAuth request and save parameters
            if (mcpService.checkMcpFromResourceUrl()) {
                // Initialize and save OAuth params to session storage
                mcpService.initializeOAuthParams();
            }

            // Initialize upcomingPayment object and manage cookie
            $rootScope.upcomingPayment = null;

            // Function to update body class based on payment warning visibility
            function updateBodyClass() {
                $timeout(function () {
                    var showWarning = $rootScope.upcomingPayment &&
                        $rootScope.upcomingPayment.unpaidPrice > 0 &&
                        $rootScope.upcomingPayment.paymentDaysRemaining <= $rootScope.upcomingPayment.paymentBarTreshold &&
                        !$rootScope.upcomingPayment.closedByUser;

                    if (showWarning) {
                        document.body.classList.add('has-payment-warning');
                    } else {
                        document.body.classList.remove('has-payment-warning');
                    }
                }, 100);
            }

            // Function to get upcomingPayment from cookie
            function getUpcomingPaymentFromCookie() {
                var cookieData = $cookies.get('upcomingPayment');

                if (cookieData) {
                    try {
                        $rootScope.upcomingPayment = JSON.parse(cookieData);
                        updateBodyClass();
                    } catch (e) {
                        console.warn('Error parsing upcomingPayment cookie:', e);
                        $rootScope.upcomingPayment = null;
                    }
                } else {
                    orders_factory.my().$promise.then(function (response) {
                        // Filter orders that meet specified conditions
                        if (response && response.orders) {
                            var filteredOrder = response.orders.find(function (order) {
                                // Check order level conditions
                                var orderConditions = order.completedPayment === false &&
                                    order.orderCancellationReason === null &&
                                    order.hasContract === true &&
                                    [50, 80].indexOf(order.status) !== -1 &&
                                    (order.installmentType !== 20 || order.amountPaid > 0);

                                // Check if order has the specific product type
                                var hasTargetProduct = order.products && order.products.some(function (product) {
                                    return product.isPackageProduct === false && product.productType === 20;
                                });

                                return orderConditions && hasTargetProduct;
                            });

                            if (filteredOrder) {
                                $rootScope.upcomingPayment = {
                                    paymentOrderId: filteredOrder.orderId,
                                    paymentDate: null,
                                    unpaidPrice: null,
                                    product: null,
                                    paymentDaysRemaining: null,
                                    closedByUser: false,
                                    notificationIsRead: false,
                                    notificationCreatedDate: new Date().toISOString(),
                                    paymentBarTreshold: 3,
                                    notificationTreshold: 7
                                };
                                // Determine which date to use based on installmentType
                                if (filteredOrder.installmentType === 20) {
                                    // Taksitli ödeme - isPayed false olan ilk taksiti bul
                                    var unpaidInstallment = null;
                                    if (filteredOrder.installments && filteredOrder.installments.length > 0) {
                                        unpaidInstallment = filteredOrder.installments.find(function (installment) {
                                            return installment.isPayed === false;
                                        });
                                    }

                                    if (unpaidInstallment) {
                                        $rootScope.upcomingPayment.paymentDate = unpaidInstallment.paymentDate;
                                        $rootScope.upcomingPayment.unpaidPrice = unpaidInstallment.price;
                                    } else {
                                        $rootScope.upcomingPayment.paymentDate = filteredOrder.paymentDueDate;
                                        $rootScope.upcomingPayment.unpaidPrice = 0;
                                    }
                                } else {
                                    // Cash payment – use the due date.
                                    $rootScope.upcomingPayment.paymentDate = filteredOrder.paymentDueDate;
                                    $rootScope.upcomingPayment.unpaidPrice = (filteredOrder.orderPrice - filteredOrder.amountPaid);
                                }

                                // Get product details
                                if (filteredOrder.products && filteredOrder.products.length > 0) {
                                    var pendingPaymentProduct = filteredOrder.products.find(function (product) {
                                        return product.isPackageProduct === false && product.productType === 20;
                                    });

                                    if (pendingPaymentProduct) {
                                        $rootScope.upcomingPayment.product = pendingPaymentProduct;
                                    }
                                }

                                // Calculate remaining days until target date
                                if ($rootScope.upcomingPayment.unpaidPrice && $rootScope.upcomingPayment.product) {
                                    var today = moment().startOf('day');
                                    // Parse database date as UTC and convert to user's local timezone
                                    var dueDateLocal = moment.utc($rootScope.upcomingPayment.paymentDate).local();
                                    var dueDate = dueDateLocal.startOf('day');
                                    // Calculate difference in days
                                    var daysDifference = dueDate.diff(today, 'days');

                                    // Assign to $rootScope
                                    $rootScope.upcomingPayment.paymentDaysRemaining = daysDifference;

                                    $rootScope.setUpcomingPaymentToCookie($rootScope.upcomingPayment);
                                }
                            } else {
                                $rootScope.setUpcomingPaymentToCookie(null);
                            }
                        }
                    }, function (error) {
                        // console.error('Orders verisi alınırken hata oluştu:', error);
                    });
                }
            }

            // Function to set upcomingPayment to cookie
            $rootScope.setUpcomingPaymentToCookie = function (paymentData) {
                var expiryDate = new Date();
                expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000)); // 24 hours
                $cookies.put('upcomingPayment', JSON.stringify(paymentData), { expires: expiryDate });
                $rootScope.upcomingPayment = paymentData;
                updateBodyClass();
            };

            $rootScope.deleteUpcomingPaymentFromCookie = function () {
                $cookies.remove('upcomingPayment');
                $rootScope.upcomingPayment = null;
            };

            // Function to close payment warning and update cookie
            $rootScope.closePaymentWarning = function () {
                $rootScope.upcomingPayment.closedByUser = true;
                $rootScope.setUpcomingPaymentToCookie($rootScope.upcomingPayment);
                updateBodyClass();
            };

            userSvc.getUserInfo(true).then(function (result) {
                
                if ($rootScope.SignedIn)
                    getUpcomingPaymentFromCookie();
                if (window.location.pathname.indexOf('/account') === -1)
                    if (!window.localStorage.getItem('profile_completion_notifier') && $rootScope.SignedIn && ($rootScope.recommendedFieldsToFill.isAgent ? !$rootScope.recommendedFieldsToFill.isComplete : false)) {
                        $ocLazyLoad.load([
                            "/assets/js/vendor.phone.min.js?v=" + window.appVersion,
                            "/assets/js/vendor.wizard.min.js?v=" + window.appVersion,
                            "/assets/js/vendor.upload.min.js?v=" + window.appVersion,
                            "/assets/css/vendor.summernote.min.css?v=" + window.appVersion,
                            "/assets/js/vendor.summernote.min.js?v=" + window.appVersion,
                        ]).then(function () {
                            ngDialog.open({
                                templateUrl: "app/shell/profile-completion.modal.html",
                                controller: [
                                    "$scope",
                                    "userSvc",
                                    "$timeout",
                                    "notificationService",
                                    function ($scope, userSvc, $timeout) {
                                        $scope.userData = angular.copy(userSvc.info);

                                        $scope.accountFields = [
                                            "isPhoneNumberFilled",
                                            "isPhoneConfirmed",
                                            "isEmailFilled",
                                            "isEmailConfirmed",
                                            "hasAvatar"
                                        ];
                                        $scope.companyFields = [
                                            "isAboutFilled",
                                            "isSloganFilled"
                                        ];

                                        var charLimitAbout = 1500;

                                        $scope.accountComplete = false;
                                        $scope.companyComplete = false;

                                        function updateCompletionStatus() {
                                            $scope.accountComplete = $scope.accountFields.every(
                                                field => $rootScope.recommendedFieldsToFill[field] === true
                                            );

                                            $scope.companyComplete = $scope.companyFields.every(
                                                field => $rootScope.recommendedFieldsToFill[field] === true
                                            );

                                        };

                                        updateCompletionStatus();

                                        $scope.noteLang = window.lang === 'tr' ? 'tr-TR' : window.lang === 'en' ? 'en-US' : window.lang;
                                        $scope.noteOptions = {
                                            height: 300,
                                            focus: false,
                                            airMode: false,
                                            styleWithSpan: false,
                                            enterMode: 'br',
                                            toolbar: [
                                                ['edit', ['undo', 'redo']],
                                                ['style', ['bold', 'italic', 'underline', 'clear']],
                                            ],
                                            callbacks: {
                                                onChange: function (contents, $editable) {
                                                    if (contents.length > charLimitAbout) {
                                                        $scope.aboutErr = true;
                                                    } else {
                                                        $scope.aboutErr = false;
                                                    }
                                                    $($editable).find('p').removeAttr('style');
                                                },
                                                onPaste: function (e) {
                                                    var text = e.originalEvent.clipboardData.getData('text');
                                                    e.preventDefault();
                                                    document.execCommand('insertText', false, text);
                                                },
                                            }
                                        };

                                        $scope.image = {
                                            // src: null, /* { fileType: "image/png"; imageData: "data:image/png;base64,..." } */
                                            src: null,
                                            dst: null /* "data:image/png;base64,..." */
                                        };

                                        $scope.loadImage = function (file) {
                                            var fileReader = new FileReader();
                                            fileReader.readAsDataURL(file);
                                            fileReader.onload = function (e) {
                                                var dataUrl = e.target.result;
                                                $scope.$apply(function () { $scope.image.src = dataUrl; });
                                            };
                                        };

                                        $scope.imgUpdating = false;

                                        $scope.updateMyAvatar = function () {
                                            $scope.imgUpdating = true;
                                            userSvc.updateAvatar($scope.image).then(function (result) {
                                                $scope.userData = result;
                                                $scope.userData.Details.profile.lastModifiedDate = result.lastModifiedDate;
                                            }).finally(function () {
                                                $scope.image.dst = null;
                                                $scope.image.src = null;
                                                $scope.imgUpdating = false;
                                            });
                                        };


                                        $scope.mailValidation = {
                                            valid: true,
                                            registered: false,
                                            changed: false,
                                            waitingOtp: false
                                        };
                                        $scope.phoneValidation = {
                                            valid: true,
                                            registered: false,
                                            changed: false,
                                            waitingOtp: false
                                        };

                                        // Captcha state
                                        $scope.ETToken = null;
                                        $scope.captchaVerified = false;
                                        $scope.isTurkishPhone = true;
                                        $scope.eimageCaptchaKey = null;
                                        $scope.eimageCaptchaValue = null;

                                        $scope.selectedLanguage = window.langCode();
                                        $scope.sourceLang = window.langCode();

                                        $scope.aboutDetails = [];
                                        $scope.selectedLanguage = window.langCode();

                                        $scope.userData.Details.profile.aboutDetails.forEach(element => {
                                            $scope.aboutDetails[element.language] = element;
                                        });

                                        $scope.goProfile = function goProfile() {
                                            ngDialog.close();
                                            $state.go('profile.account', { langcode: window.lang });
                                        };

                                        $scope.updateProfile = function () {
                                            // Prevent function execution if the button should be disabled based on validation rules
                                            if ($scope.aboutErr ||
                                                ($scope.userData.Details.phoneNumber && ($scope.phoneValidation.waitingOtp || $scope.phoneValidation.registered || !$scope.phoneValidation.valid)) ||
                                                ($scope.userData.Details.email && ($scope.mailValidation.waitingOtp || $scope.mailValidation.registered || !$scope.mailValidation.valid))) {
                                                return;
                                            }

                                            if (!$scope.userData.Details.phoneNumber) { $scope.userData.Details.phoneNumber = null; }
                                            else {
                                                $scope.userData.Details.phoneNumber = $scope.userData.Details.phoneNumber.replace(/\s+/g, '');
                                            }

                                            $scope.updateLoading = true;

                                            $scope.userData.Details.profile.aboutDetails = [];
                                            var elArr = [];
                                            $scope.userData.Details.profile.SpokenLanguages.forEach(element => {
                                                elArr.push(+element);
                                            });

                                            $scope.aboutDetails.forEach(element => {
                                                if (element) {
                                                    element.language = element.language ? element.language : $scope.aboutDetails.indexOf(element);
                                                    var cleanedContents = element.about ? element.about.replace(/`/g, '\'') : '';
                                                    element.about = cleanedContents;
                                                    $scope.userData.Details.profile.aboutDetails.push(element);
                                                }
                                            });

                                            updateUser();

                                        };

                                        function updateUser() {
                                            user_factory.update($scope.userData.Details).$promise.then(
                                                function (result) {
                                                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                                                    CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                                                    CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
                                                    CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
                                                    CacheFactory.get('AgentsSearch') && CacheFactory.get('AgentsSearch').removeAll();
                                                    $scope.userData.Details.profile.lastModifiedDate = result.lastModifiedDate;

                                                    notifierSvc.show({ message: $translate.instant('account_updated'), type: "success" });
                                                    userSvc.getUserInfo(true).then(function (result) {
                                                        $scope.userData = angular.copy(userSvc.info);
                                                        window.oldPhoneNumber = $scope.userData.Details.phoneNumber;
                                                        window.oldMailAddress = $scope.userData.Details.email;
                                                    });
                                                    ngDialog.close();

                                                },
                                                function (err) {
                                                    console.log(err);
                                                    if (err.data.detail.includes("updated with newer")) {
                                                        notifierSvc.show({ message: $translate.instant('account_update_error'), type: "error" });
                                                    } else {
                                                        notifierSvc.show({ message: $translate.instant('account_error'), type: "error" });
                                                    }
                                                }
                                            ).finally(() => $scope.updateLoading = false);
                                        }

                                        window.localStorage.setItem('profile_completion_notifier', 1);
                                    },
                                ],
                                closeByNavigation: false,
                                closeByDocument: false,
                                closeByEscape: false,
                            });

                        });
                    };
            });

            $timeout(function () {
                if ($rootScope.SignedIn) {
                    notificationService.purgeCache();
                    notificationService.getNotifications();

                    // Lazy load Socket.io library (only for signed-in users)
                    if (typeof io === 'undefined') {
                        var script = document.createElement('script');
                        script.src = '/assets/js/vendor.socket.min.js?v=' + window.appVersion;
                        script.async = false;  // Load synchronously to ensure io is available
                        script.onload = function () {
                            initializeSocket();
                        };
                        document.head.appendChild(script);
                    } else {
                        initializeSocket();
                    }
                }

                function initializeSocket() {
                    var socketUrl = location.host === "beta.endeksa.com"
                        ? "wss://noti-beta.endeksa.com"
                        : "wss://noti.endeksa.com";

                    window.socket = io(socketUrl, {
                        reconnection: true,
                        reconnectionDelayMax: 10000,
                        transports: ['websocket'],
                        auth: {
                            token: 'M05EM0tTNEZSME5UM05E'
                        }
                    });



                    window.socket.on('connect', function (data) {
                        console.log("connect", data);
                        $window.socket.emit('join', { userid: userSvc.info.Id });

                        window.socket.on('signalClient', function (data) {
                            console.log("socket serverdata", data);
                            notificationService.purgeCache();
                            notificationService.getNotifications();
                        });
                    });

                    window.socket.on("disconnect", (reason) => {
                        if (window.socket.active) {
                            // temporary disconnection, the socket will automatically try to reconnect
                        } else {
                            // the connection was forcefully closed by the server or the client itself
                            // in that case, `socket.connect()` must be manually called in order to reconnect
                            console.log("Endeksa socket disconnected: " + reason);
                        }
                    });

                    // ⚡ BFCache optimization: Properly manage WebSocket connections
                    // Disconnect when page enters bfcache, reconnect when restored
                    // Reference: https://web.dev/bfcache/#optimize-your-pages-for-bfcache
                    window.addEventListener('pagehide', function (event) {
                        if (event.persisted && window.socket) {
                            console.log('[BFCache] Page entering bfcache, disconnecting socket');
                            window.socket.disconnect();
                        }
                    });

                    window.addEventListener('pageshow', function (event) {
                        if (event.persisted && window.socket && !window.socket.connected) {
                            console.log('[BFCache] Page restored from bfcache, reconnecting socket');
                            window.socket.connect();
                        }
                    });
                } // end initializeSocket()
            });

            $rootScope.normalizeAddress = $window.normalizeAddress;

            $rootScope.hasHistory = function () {
                return $window.referrer && $window.referrer !== $window.location.href;
            };

            $rootScope.proceedBack = function () {
                $window.history.back();
                endeksService.clearTempEndeks();
            };

            $rootScope.isMobileOrTablet = $window.isMobileOrTablet;

            $rootScope.agentAddress = function (agent) {
                if (!agent)
                    return "";
                if (agent.UserInfo)
                    return normalizeAddress(agent.UserInfo.UserName.trim() + '-' + agent.UserInfo.UserSurname.trim());
                else if (agent.Details)
                    return normalizeAddress(agent.Details.profile.name.trim() + '-' + agent.Details.profile.surName.trim());
                else if (agent.Name)
                    return normalizeAddress(agent.Name.trim() + '-' + agent.Surname.trim());
            };

            $rootScope.toggleNotifications = function (showAnnouncements = false) {
                $rootScope.isVisible = !$rootScope.isVisible;
                if ($rootScope.isVisible) {
                    if (showAnnouncements)
                        $rootScope.$broadcast('nc_visible_80');

                    $rootScope.$broadcast('nc_visible');
                }
            };

            $rootScope.unreadNotifications = 0;

            $rootScope.mallAddress = function (propertiesInfo) {
                if (!propertiesInfo)
                    return "javascript:void(0);";
                var langKey = $window.lang;
                return $state.href("mall-detail", {
                    langcode: langKey,
                    id: propertiesInfo.Id,
                    name: normalizeAddress(propertiesInfo.Title.trim()),
                });
            };

            $rootScope.projectAddress = function (propertiesInfo) {
                if (!propertiesInfo)
                    return "javascript:void(0);";
                var langKey = $window.lang;
                return $state.href("project-detail", {
                    langcode: langKey,
                    id: propertiesInfo.Id,
                    name: normalizeAddress(propertiesInfo.Name.trim()),
                });
            };

            $rootScope.districtAddress = function (propertiesNeighbourhood) {
                if (!propertiesNeighbourhood)
                    return "javascript:void(0);";
                var neighbourhood = normalizeAddress(
                    propertiesNeighbourhood.City +
                    "-" +
                    propertiesNeighbourhood.County +
                    "-" +
                    propertiesNeighbourhood.District
                );
                var langKey = $window.lang;
                return $state.href("neighbourSection.details", {
                    langcode: langKey,
                    id: propertiesNeighbourhood.DistrictId,
                    neighbourhood: neighbourhood,
                });
            };


            $rootScope.opportunityUrlCreator = function (propertiesInfo, lang = null) {
                if (!propertiesInfo)
                    return "javascript:void(0);";
                var langKey = lang ? lang : (window.lang || 'tr');
                var ev =
                    propertiesInfo.PropertyCategory === 2 ?
                        $translate.instant("ticari", {}, null, langKey || null) : propertiesInfo.PropertyCategory === 3 ?
                            $translate.instant("arsa", {}, null, langKey || null) : propertiesInfo.PropertyType === null ?
                                $translate.instant("konut", {}, null, langKey || null) :
                                +propertiesInfo.PropertyType === 10 ?
                                    $translate.instant("daire", {}, null, langKey || null) :
                                    $translate.instant("mustakil-ev", {}, null, langKey || null);
                var name = normalizeAddress(propertiesInfo.GeoLocation.CityName) + '-' + normalizeAddress(propertiesInfo.GeoLocation.CountyName) + '-' + normalizeAddress(propertiesInfo.GeoLocation.Name) + '-' + $translate.instant("satilik", {}, null, langKey || null) + "-" + ev;
                return $state.href('localInfo.property', { langcode: langKey, id: propertiesInfo.PortfolioId, name: name });
            };

            $rootScope.opportunityAddress = function (propertiesInfo) {
                if (!propertiesInfo)
                    return "javascript:void(0);";
                var langKey = $window.lang || 'en';
                const currentUrl = propertiesInfo.Details ? propertiesInfo.Details.find(m => m.Language === window.langCode())?.Url || '' : '';
                return $state.href('localInfo.property', { langcode: langKey, id: propertiesInfo.PortfolioId, name: currentUrl });
            };

            $rootScope.durationCalc = function (time) {
                return time <= 30 ? '0-30' : time > 30 && time <= 60 ? '30-60' : time > 60 && time < 90 ? '60-90' : '90'; //time < 180 ? time : 180;
            };

            // $rootScope.openMemberCalendar = function (type) {
            //     ngDialog.open({
            //         templateUrl: $window.lang === 'tr' ? 'app/shell/calendar-member.html' : 'app/shell/calendar-english.html',
            //         overlay: true,
            //         closeByEscape: true,
            //         showClose: false,
            //         closeByNavigation: true,
            //         closeByDocument: true,
            //         controller: ['$scope', 'userSvc', function ($scope, userSvc) {
            //             if (userSvc.info.SignedIn)
            //                 userSvc.getUserInfo().then(function (account) {
            //                     $scope.account = account.information;
            //                 });
            //             else
            //                 $scope.account = { profile: {} };
            //             $scope.type = type;
            //         }]
            //     });
            // };
            var actionDialog = null;
            var actionDisplayed = false;
            $rootScope.actionType = function (country, city, county, district, address) {
                if (!$rootScope.SignedIn)
                    $state.go('valuation-wrapper', { langcode: $window.lang, address: address });
                else
                    if (!actionDisplayed && !actionDialog)
                        actionDialog = ngDialog.open({
                            showClose: false,
                            closeByEscape: false,
                            closeByNavigation: false,
                            template: "./app/shell/action-type.html",
                            data: {
                                showClose: false,
                            },
                            preCloseCallback: function () {
                                actionDialog = null;
                                actionDisplayed = false;
                            },
                            controller: [
                                "$scope",
                                function ($scope) {
                                    actionDisplayed = true;
                                    $scope.analysis_country = country;
                                    $scope.analysis_city = city;
                                    $scope.analysis_county = county;
                                    $scope.analysis_district = district;
                                    $scope.analysis_address = address;

                                    $scope.analysis_level = 'country';
                                    if (city)
                                        $scope.analysis_level = 'province';
                                    if (county)
                                        $scope.analysis_level = 'county';
                                    if (district)
                                        $scope.analysis_level = 'neighbourhood';
                                    if (address)
                                        $scope.analysis_level = 'address';


                                    var currentstate = $window.localStorage.getItem('currentState');
                                    $scope.analysis_state = currentstate && currentstate.split('.')[2] ? currentstate.split('.')[2] : 'value';

                                },
                            ],
                        });
            };

            $transitions.onSuccess({}, function () { if (actionDialog) actionDialog.close(); });

            var askDisplayed = false;
            var askMemberDialog = null;
            $rootScope.askMembership = function (passDisplayed, fromDetail = false) {
                if (!askDisplayed && $state.current.name.indexOf("opportunity") === -1 &&
                    !$rootScope.unRegisteredUser &&
                    $state.current.name.indexOf("projects") === -1 &&
                    $state.current.name.indexOf("malls") === -1 &&
                    $state.current.name.indexOf("alarm") === -1 &&
                    $state.current.name.indexOf("agents") === -1 &&
                    $state.current.name.indexOf("portfolio") === -1 &&
                    $rootScope.SignedIn && !askMemberDialog)
                    askMemberDialog = ngDialog.open({
                        showClose: false,
                        // overlay: false,
                        closeByEscape: false,
                        closeByNavigation: false,
                        template: "./app/shell/modal-buy-package.html",
                        data: {
                            showClose: false,
                        },
                        preCloseCallback: function () {
                            askMemberDialog = null;
                        },
                        controller: [
                            "$scope",
                            "$state",
                            "paymentService",
                            "$filter",
                            function ($scope, $state, paymentService, $filter) {
                                $scope.fromDetail = fromDetail;
                                askDisplayed = !passDisplayed ? true : false;
                                paymentService.getProducts().then(
                                    function (response) {
                                        var packages = $filter('filter')(response.data, { code: "basic-package", productType: 40 })[0];
                                        var pack = $filter('filter')(packages.prices, { currency: $rootScope.currencyKey })[0];
                                        $scope.packPrice = pack.monthlyPrice;
                                        $scope.currencySymbol = $window.currencySymbolByEndeksaCode(pack.currency);
                                    });

                                $scope.proceedBuy = function () {
                                    $state.go('odeme-onepage', { code: 'basic-package', langcode: $window.lang, type: 40 });
                                };
                            },
                        ],
                    });
            };

            $rootScope.cleanInput = function (item) {
                item = item || $rootScope.address;
                item = null;
                $rootScope.address = null;
                $rootScope.$broadcast("input_cleaned", {});
                if (typeHead)
                    $(typeHead).typeahead('close');
                $rootScope.debounce = false;
            };

            var typeHead;
            $rootScope.initAutoComplete = function (id, btn) {
                typeHead = id;
                var debounceTiemout;

                $timeout(function () {
                    var that = this;

                    $(id).typeahead({
                        source: function (query, process) {
                            if (debounceTiemout) {
                                clearTimeout(debounceTiemout);
                            }
                            debounceTiemout = setTimeout(function () {
                                $rootScope.debounce = true;
                                if (query.indexOf('http') > -1 || query.indexOf('www') > -1) {
                                    $rootScope.$broadcast("link_defined", { query: query });
                                    return process([]);
                                }
                                var end = process(["loading"]);
                                var results1 = [];
                                var results2 = [];
                                var results4 = [];
                                var results5 = [];
                                var results6 = [];
                                var results7 = [];
                                var results8 = [];
                                var results9 = [];
                                var results10 = [];

                                const countryId = ($rootScope.country === 'turkiye' || bolgeselDataService.country === 'turkiye') ? 1 : ($rootScope.country === 'espana' || bolgeselDataService.country === 'espana') ? 2 : ($rootScope.country === 'portugal' || bolgeselDataService.country === 'portugal') ? 3 : 0;
                                const langu = countryId === 1 ? 'tr_TR' : countryId === 2 ? 'es_ES' : countryId === 3 ? 'pt_PT' : 'en_US';

                                const bbox = bolgeselDataService.cityBounds && bolgeselDataService.cityBounds.southWest && countryId > 0 ? bolgeselDataService.cityBounds.southWest.lng + "," + bolgeselDataService.cityBounds.southWest.lat + "~" + bolgeselDataService.cityBounds.northEast.lng + "," + bolgeselDataService.cityBounds.northEast.lat : undefined;

                                if (query.length > 2) {
                                    if (countryId !== 1) {
                                        $ocLazyLoad.load([
                                            'js!https://maps.googleapis.com/maps/api/js?key=AIzaSyA1R2wFiWEsC5N0D_gHwm8l0qOMf4NWvgY&libraries=places&language=' + window.lang
                                        ]).then(function () {
                                            var service = new google.maps.places.AutocompleteService();
                                            service.getPlacePredictions({
                                                input: query,
                                                componentRestrictions: { country: langu.split('_')[0] },
                                                language: langu.split('_')[0]
                                            }, function (predicts, status) {
                                                results1.length = 0;
                                                if (status === google.maps.places.PlacesServiceStatus.OK) {
                                                    var predictions = [];

                                                    for (var i = 0; i < predicts.length; i++) {
                                                        const country_name = predicts[i].terms[predicts[i].terms.length - 1].value;
                                                        var item = {
                                                            name: predicts[i].description.replace(', ' + country_name, '').replace('/', ', '),
                                                            description: ', ' + country_name,
                                                            longlat: null,
                                                            country: country_name,
                                                            place: predicts[i].place_id,
                                                            type: predicts[i].type ? predicts[i].type : predicts[i].types[0],
                                                            alt_type: predicts[i].alt_type ? predicts[i].alt_type : predicts[i].types[1],
                                                            alt_type2: predicts[i].types[2]
                                                        };
                                                        predictions.push(item);
                                                    }
                                                    if (predictions && predictions.length) {
                                                        results1 = $.map(predictions,
                                                            function (prediction) {
                                                                if (prediction.name !== prediction.description) {
                                                                    var dest = prediction.name + prediction.description;
                                                                    dest = dest.replace(', Eyüp', ', Eyüpsultan');
                                                                    dest = '||' + prediction.country + '||' + dest;

                                                                    if (prediction.type !== "shopping_mall" && prediction.name.indexOf('Gar') === -1 && (prediction.type !== "administrative_area_level_4" && (prediction.name.indexOf('Sokağı') > -1 || prediction.name.indexOf('Cadde') > -1 || prediction.name.indexOf('Sokak') > -1 || prediction.type === "route" || prediction.type === "street_address")) && prediction.name.indexOf(' no ') === -1 && prediction.name.indexOf('Otopark') === -1 && prediction.alt_type2 !== "establishment") {
                                                                        dest = "6>" + dest + "|sokak|p:" + prediction.place;
                                                                    }
                                                                    else if ((prediction.name.indexOf('Calle') > -1 || prediction.name.indexOf('Sokağı') > -1 || prediction.name.indexOf('Cadde') > -1 || prediction.name.indexOf('Sokak') > -1) && prediction.name.indexOf(' no ') > -1) {
                                                                        dest = "0>" + dest + "|konut|p:" + prediction.place;
                                                                    }
                                                                    else if ((prediction.type === "establishment" || prediction.alt_type === "establishment" ||
                                                                        prediction.alt_type2 === "establishment" || prediction.alt_type === "health" || prediction.alt_type === "gym")
                                                                        && prediction.name.indexOf('Muhtar') === -1
                                                                        && (prediction.type === "shopping_mall")
                                                                        && prediction.alt_type) {
                                                                        dest = "4>" + dest + "|site|p:" + prediction.place;
                                                                    }
                                                                    else if (prediction.type === "neighborhood") {
                                                                        dest = "3>" + dest + "|mahalle|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "administrative_area_level_4" &&
                                                                        prediction.alt_type === "political") {
                                                                        dest = "3>" + dest + "|mahalle|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "administrative_area_level_3" &&
                                                                        prediction.alt_type === "political") {
                                                                        dest = "3>" + dest + "|mahalle|p:" + prediction.place;
                                                                    }
                                                                    else if (prediction.type === "administrative_area_level_2" &&
                                                                        prediction.alt_type === "political") {
                                                                        dest = "2>" + dest + "|ilce|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "administrative_area_level_1" &&
                                                                        prediction.alt_type === "political") {
                                                                        dest = "1>" + dest + "|vilayet|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "locality" &&
                                                                        prediction.alt_type === "political" && prediction.name.indexOf(',') === -1) {
                                                                        dest = "1>" + dest + "|vilayet|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "locality" &&
                                                                        prediction.alt_type === "political" && dest.split(',').length > 2) {
                                                                        var isCity = false;
                                                                        if (dest.split(',')[0].trim() === dest.split(',')[2].trim()) {
                                                                            //dest = dest.replace(dest.split(',')[0].trim(), dest.split(',')[1].trim());
                                                                            isCity = true;
                                                                        }
                                                                        else if (dest.split(',').length > 3 && dest.split(',')[0].trim() === dest.split(',')[3].trim()) {
                                                                            dest = dest.replace(dest.split(',')[0].trim() + ', ', '');
                                                                        }
                                                                        else if (dest.split(',').length > 3 && dest.split(',')[1].trim().indexOf(dest.split(',')[0].trim()) > -1) {
                                                                            dest = dest.replace(dest.split(',')[0].trim() + ', ', '');
                                                                        }
                                                                        dest = !isCity ? "3>" + dest + "|mahalle|p:" + prediction.place : "1>" + dest.split(',')[0] + "|vilayet|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "locality" &&
                                                                        prediction.alt_type === "political" && dest.indexOf(',') > -1) {
                                                                        dest = "2>" + dest + "|ilce|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "colloquial_area" && prediction.name.indexOf("Mahallesi") !== -1) {
                                                                        dest = "3>" + dest + "|mahalle|p:";
                                                                    }
                                                                    else {
                                                                        dest = "7>" + dest + "|other|p:" + prediction.place;
                                                                    }

                                                                    //dest = "8>" + dest + "|other|p:" + prediction.place;

                                                                    if (dest.indexOf('|sokak|') === -1
                                                                        && dest.indexOf('|konut|') === -1
                                                                        && dest.indexOf('|other|') === -1
                                                                        && dest.indexOf('|mahalle|') === -1
                                                                        && dest.indexOf('|site|') === -1
                                                                        && $(that).attr('data-from') === "alarm")
                                                                        return null;

                                                                    return dest;
                                                                } else
                                                                    return null;
                                                            });
                                                    }
                                                    var results = [];
                                                    results = results.concat(results1);
                                                    results = results.concat(results2);
                                                    results = results.concat(results4);
                                                    results = results.concat(results5);
                                                    results = results.concat(results6);
                                                    results = results.concat(results7);
                                                    results = results.concat(results8);
                                                    results = results.concat(results9);
                                                    results = results.concat(results10);
                                                    results.sort(function (a, b) {
                                                        var nameA = (+a.split('>')[0]),
                                                            nameB = (+b.split('>')[0]);
                                                        if (nameA < nameB)
                                                            return -1;
                                                        if (nameA > nameB)
                                                            return 1;
                                                        return 0;
                                                    });
                                                    end = process(results);
                                                }
                                            });
                                        });
                                    }
                                    else {
                                        const jsonUrl = 'https://geocode-maps.yandex.ru/1.x/?apikey=ea627200-e11e-49f5-b1b7-3c79067019c9&results=5' + (bbox ? ('&bbox=' + bbox) : '') + '&format=json&lang=' + langu + (bbox ? '&rspn=1' : '') + '&geocode=' +
                                            encodeURI(query);

                                        $.getJSON(jsonUrl, function (data) {
                                            results2.length = 0;
                                            var predictions2 = [];
                                            for (var i = 0; i < data.response.GeoObjectCollection.featureMember.length; i++) {
                                                var item = {
                                                    name: data.response.GeoObjectCollection.featureMember[i].GeoObject.name,
                                                    description: data.response.GeoObjectCollection.featureMember[i].GeoObject.description,
                                                    longlat: data.response.GeoObjectCollection.featureMember[i].GeoObject.Point.pos,
                                                    type: data.response.GeoObjectCollection.featureMember[i].GeoObject.metaDataProperty.GeocoderMetaData.kind,
                                                    alt_type: data.response.GeoObjectCollection.featureMember[i].GeoObject.metaDataProperty.GeocoderMetaData
                                                };
                                                if (!item || !item.description)
                                                    continue;
                                                predictions2.push(item);
                                            }
                                            if (predictions2 && predictions2.length) {
                                                results2 = $.map(predictions2,
                                                    function (prediction) {

                                                        if (prediction.name !== prediction.description) {
                                                            var dest = prediction.name + ", " + prediction.description;
                                                            dest = '||' + prediction.alt_type.Address.country_code + '||' + dest;
                                                            dest = dest.replace(', ' + prediction.alt_type.AddressDetails.Country.CountryName, '');

                                                            if (prediction.type === "district" &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea
                                                                    .Locality.DependentLocality.DependentLocality) {
                                                                dest = "4>" + dest + "|site|l:" + prediction.longlat;
                                                            } else if (dest.indexOf('Yenikapı') === -1 && prediction.type === "district" &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea && prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea) {
                                                                dest = "3>" + dest + "|mahalle|l:" + prediction.longlat;
                                                            }
                                                            else if (prediction.type === "other" && prediction.alt_type.AddressDetails.Country.AdministrativeArea &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea.Locality.Premise) {
                                                                return null;
                                                            }
                                                            else if (prediction.type === "area") {
                                                                dest = "2>" + dest + "|ilce|l:" + prediction.longlat;
                                                            } else if (prediction.type === "locality") {
                                                                if (prediction.alt_type.AddressDetails && prediction.alt_type.AddressDetails.Country.AdministrativeArea &&
                                                                    prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                        .SubAdministrativeArea) {
                                                                    if (prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                        .SubAdministrativeArea.Locality.DependentLocality &&
                                                                        prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                            .SubAdministrativeArea.Locality.DependentLocality
                                                                            .DependentLocality && prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                                .SubAdministrativeArea.Locality.DependentLocality
                                                                                .DependentLocalityName.indexOf('Municipios') === -1) {
                                                                        dest = "3>" + dest + "|mahalle|l:" + prediction.longlat;
                                                                    }
                                                                    else if (prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                        .SubAdministrativeArea.Locality.DependentLocality &&
                                                                        prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                            .SubAdministrativeArea.Locality.DependentLocality
                                                                            .DependentLocality && prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                                .SubAdministrativeArea.Locality.DependentLocality
                                                                                .DependentLocalityName.indexOf('Municipios') > -1) {
                                                                        dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                    } else if (prediction.alt_type.AddressDetails.Country
                                                                        .AdministrativeArea
                                                                        .SubAdministrativeArea.Locality.DependentLocality) {
                                                                        //TODO: köyleri şimdilik ihmal edelim.
                                                                        return null;
                                                                    } else if (prediction.alt_type.AddressDetails.Country
                                                                        .AdministrativeArea.AdministrativeAreaName ===
                                                                        prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                            .SubAdministrativeArea.Locality.LocalityName) {
                                                                        dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                    } else if (prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                        .SubAdministrativeArea && prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                            .SubAdministrativeArea.SubAdministrativeAreaName.indexOf('Provincia') > -1) {
                                                                        dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                    } else if (dest.length <= 14) {
                                                                        dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                    } else {
                                                                        dest = "2>" + dest + "|ilce|l:" + prediction.longlat;
                                                                    }
                                                                } else { //All those come here are provinces always, still being tested on preprod
                                                                    dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                }
                                                            }
                                                            else if (prediction.type === "street") {
                                                                dest = "6>" + dest + "|sokak|l:" + prediction.longlat;
                                                            }
                                                            else if (prediction.type === "house") {
                                                                dest = "0>" + dest + "|konut|l:" + prediction.longlat;
                                                            } else if (prediction.type === "province") {
                                                                dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                            } else {
                                                                dest = "13>" + dest + "|other|l:" + prediction.longlat;
                                                            }
                                                            if (dest.indexOf('|mahalle|') === -1 &&
                                                                dest.indexOf('|sokak|') === -1 &&
                                                                dest.indexOf('|konut|') === -1 &&
                                                                dest.indexOf('|other|') === -1 &&
                                                                dest.indexOf('|site|') === -1 &&
                                                                $(that).attr('id') === 'alarm-input')
                                                                return null;
                                                            return dest;
                                                        } else
                                                            return null;
                                                    });

                                                var results = [];
                                                results = results.concat(results1);
                                                results = results.concat(results2);
                                                results = results.concat(results4);
                                                results = results.concat(results5);
                                                results = results.concat(results6);
                                                results = results.concat(results7);
                                                results = results.concat(results8);
                                                results = results.concat(results9);
                                                results = results.concat(results10);
                                                results.sort(function (a, b) {
                                                    var nameA = (+a.split('>')[0]),
                                                        nameB = (+b.split('>')[0]);
                                                    if (nameA < nameB)
                                                        return -1;
                                                    if (nameA > nameB)
                                                        return 1;
                                                    return 0;
                                                });
                                                end = process(results);
                                            }
                                            else {
                                                var results = [];
                                                results = results.concat(results1);
                                                results = results.concat(results2);
                                                results = results.concat(results4);
                                                results = results.concat(results5);
                                                results = results.concat(results6);
                                                results = results.concat(results7);
                                                results = results.concat(results8);
                                                results = results.concat(results9);
                                                results = results.concat(results10);
                                                results.sort(function (a, b) {
                                                    var nameA = (+a.split('>')[0]),
                                                        nameB = (+b.split('>')[0]);
                                                    if (nameA < nameB)
                                                        return -1;
                                                    if (nameA > nameB)
                                                        return 1;
                                                    return 0;
                                                });
                                                end = process(results);
                                            }
                                        });
                                    }
                                    // $.ajax({
                                    //     type: 'GET',
                                    //     contentType: "application/json",
                                    //     dataType: 'json',
                                    //     url: 'https://' + $window.urlfx2 + '.endeksa.com/retailstreets?SearchTerm=' + query,
                                    //     success: function (data) {
                                    //         var predictions = data;
                                    //         if (predictions && predictions.length) {
                                    //             results9.length = 0;
                                    //             results9 = $.map(predictions.slice(0, 2),
                                    //                 function (prediction) {
                                    //                     var dest = '5>' + prediction.StreetName.toLocaleProperCase2("tr-tr") + ', ' + prediction.DistrictName.toLocaleProperCase2("tr-tr") + ', ' + prediction.CountyName.toLocaleProperCase2("tr-tr") + ', ' + prediction.CityName.toLocaleProperCase2("tr-tr") + '|street|' + prediction.Id + '|l:' + prediction.Lon + ' ' + prediction.Lat;
                                    //                     return dest;
                                    //                 });
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //     }

                                    // });
                                    // if (countryId)
                                    //     $http.get(appSettingsSvc.CACHE + '/searchhousingprojectname?name=' + encodeURI(query) + '&countryId=' + countryId).then(function (data) {
                                    //         var predictions = data.data.Data;
                                    //         if (predictions && predictions.length) {
                                    //             results4.length = 0;
                                    //             results4 = $.map(predictions.slice(0, 2),
                                    //                 function (prediction) {
                                    //                     var dest = '||TR||8>' + prediction.Name + '|proje|' + prediction.Id + '|l:' + prediction.Longitude + ' ' + prediction.Latitude;

                                    //                     return dest;
                                    //                 });
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //         else {
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //     });

                                    // if (countryId)
                                    //     $http.get(appSettingsSvc.CACHE + '/shoppingcentersearch?title=' + encodeURI(query) + '&countryId=' + countryId).then(function (data) {
                                    //         var predictions = data.data.Data;
                                    //         if (predictions && predictions.length) {
                                    //             results5.length = 0;
                                    //             results5 = $.map(predictions.slice(0, 2),
                                    //                 function (prediction) {
                                    //                     var dest = '||TR||9>' + prediction.Title + '|avm|' + prediction.Id + '|l:' + prediction.Lon + ' ' + prediction.Lat;

                                    //                     return dest;
                                    //                 });
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //         else {
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //     });

                                    if ($rootScope.SignedIn) {
                                        $http.post(appSettingsSvc.NONCACHE + '/tasinmazlistesearch', JSON.stringify({
                                            "UserId": userSvc.info.Id,
                                            "Search": query,
                                            // "CountryId": countryId,
                                            "DataLevel": 9,
                                            "ItemSize": 2,
                                            "ActivePageNumber": 1,
                                            "OrderBy": 1,
                                            "Sort": 2
                                        })).then(function (data) {
                                            var predictions = data.data.Properties;

                                            if (predictions && predictions.length) {
                                                results6.length = 0;
                                                results6 = $.map(predictions.slice(0, 2),
                                                    function (prediction) {
                                                        var countryTag = prediction.CountryName === 'Türkiye' ? 'TR' : prediction.CountryName === 'Portugal' ? 'PT' : 'ES';
                                                        var dest = '||' + countryTag + '||11>' + prediction.Name + ', ' + prediction.DistrictName + ', ' + prediction.CountyName + ', ' + prediction.CityName + '|endeksa|' + prediction.Id + '|l:' + prediction.Longitude + ' ' + prediction.Latitude;

                                                        return dest;
                                                    });
                                                var results = [];
                                                results = results.concat(results1);
                                                results = results.concat(results2);
                                                results = results.concat(results4);
                                                results = results.concat(results5);
                                                results = results.concat(results6);
                                                results = results.concat(results7);
                                                results = results.concat(results8);
                                                results = results.concat(results9);
                                                results = results.concat(results10);
                                                results.sort(function (a, b) {
                                                    var nameA = (+a.split('>')[0]),
                                                        nameB = (+b.split('>')[0]);
                                                    if (nameA < nameB)
                                                        return -1;
                                                    if (nameA > nameB)
                                                        return 1;
                                                    return 0;
                                                });
                                                end = process(results);
                                            }
                                            else {
                                                var results = [];
                                                results = results.concat(results1);
                                                results = results.concat(results2);
                                                results = results.concat(results4);
                                                results = results.concat(results5);
                                                results = results.concat(results6);
                                                results = results.concat(results7);
                                                results = results.concat(results8);
                                                results = results.concat(results9);
                                                results = results.concat(results10);
                                                results.sort(function (a, b) {
                                                    var nameA = (+a.split('>')[0]),
                                                        nameB = (+b.split('>')[0]);
                                                    if (nameA < nameB)
                                                        return -1;
                                                    if (nameA > nameB)
                                                        return 1;
                                                    return 0;
                                                });
                                                end = process(results);
                                            }
                                        });
                                    }

                                    // if (countryId)
                                    //     $http.post(appSettingsSvc.NONCACHE + '/portfoliosearch',
                                    //         JSON.stringify({
                                    //             "SearchTerm": query,
                                    //             "CountryId": countryId,
                                    //             "ItemSize": 2,
                                    //             "Level": 9,
                                    //             "PriceMax": 2147483647,
                                    //             "Language": $window.langCode()
                                    //         })).then(function (data) {
                                    //             var predictions = data.data.OpportunityList;
                                    //             if (predictions && predictions.length) {
                                    //                 results8.length = 0;
                                    //                 results8 = $.map(predictions.slice(0, 2),
                                    //                     function (prediction) {
                                    //                         var countryTag = prediction.GeoLocation.CountryId === 1 ? 'TR' : prediction.GeoLocation.CountryId === 3 ? 'PT' : 'ES';
                                    //                         var dest = '||' + countryTag + '||7>' + prediction.GeoLocation.Name + ', ' + prediction.GeoLocation.DistrictName + ', ' + prediction.GeoLocation.CountyName + ', ' + prediction.GeoLocation.CityName + '|opport|' + prediction.PortfolioId + '-' + prediction.PropertyCategory + '-' + prediction.PropertyType + '|l:' + prediction.GeoLocation.Longitude + ' ' + prediction.GeoLocation.Latitude;

                                    //                         return dest;
                                    //                     });
                                    //                 var results = [];
                                    //                 results = results.concat(results1);
                                    //                 results = results.concat(results2);
                                    //                 results = results.concat(results4);
                                    //                 results = results.concat(results5);
                                    //                 results = results.concat(results6);
                                    //                 results = results.concat(results7);
                                    //                 results = results.concat(results8);
                                    //                 results = results.concat(results9);
                                    //                 results = results.concat(results10);
                                    //                 results.sort(function (a, b) {
                                    //                     var nameA = (+a.split('>')[0]),
                                    //                         nameB = (+b.split('>')[0]);
                                    //                     if (nameA < nameB)
                                    //                         return -1;
                                    //                     if (nameA > nameB)
                                    //                         return 1;
                                    //                     return 0;
                                    //                 });
                                    //                 end = process(results);
                                    //             }
                                    //             else {
                                    //                 var results = [];
                                    //                 results = results.concat(results1);
                                    //                 results = results.concat(results2);
                                    //                 results = results.concat(results4);
                                    //                 results = results.concat(results5);
                                    //                 results = results.concat(results6);
                                    //                 results = results.concat(results7);
                                    //                 results = results.concat(results8);
                                    //                 results = results.concat(results9);
                                    //                 results = results.concat(results10);
                                    //                 results.sort(function (a, b) {
                                    //                     var nameA = (+a.split('>')[0]),
                                    //                         nameB = (+b.split('>')[0]);
                                    //                     if (nameA < nameB)
                                    //                         return -1;
                                    //                     if (nameA > nameB)
                                    //                         return 1;
                                    //                     return 0;
                                    //                 });
                                    //                 end = process(results);
                                    //             }
                                    //         });

                                    if (countryId)
                                        $.getJSON(appSettingsSvc.CACHE + '/search?term=' + encodeURIComponent(query) + '&searchCategoryTypes=10',
                                            function (data) {
                                                var predictions = data.Agents;
                                                if (predictions && predictions.length) {
                                                    results10.length = 0;
                                                    results10 = $.map(predictions.slice(0, 2),
                                                        function (prediction) {
                                                            var regions = prediction.Regions || [];
                                                            var region = regions.find(function (r) { return r.IsMainRegion; }) || regions[0] || {};
                                                            var countryTag = countryId === 1 ? 'TR' : countryId === 3 ? 'PT' : 'ES';
                                                            var dest = '||' + countryTag + '||13>' + prediction.Name.toLocaleProperCase2("tr-tr") + ' ' + prediction.Surname.toLocaleProperCase2("tr-tr") + (prediction.OfficeName ? ' (' + prediction.OfficeName.toLocaleProperCase2("tr-tr") + ') ' : ' ') + (region.CityName || '').toLocaleProperCase2("tr-tr") + ', ' + (region.CountyName || '').toLocaleProperCase2("tr-tr") + '|agent|' + prediction.Id;

                                                            return dest;
                                                        });
                                                    var results = [];
                                                    results = results.concat(results1);
                                                    results = results.concat(results2);
                                                    results = results.concat(results4);
                                                    results = results.concat(results5);
                                                    results = results.concat(results6);
                                                    results = results.concat(results7);
                                                    results = results.concat(results8);
                                                    results = results.concat(results9);
                                                    results = results.concat(results10);
                                                    results.sort(function (a, b) {
                                                        var nameA = (+a.split('>')[0]),
                                                            nameB = (+b.split('>')[0]);
                                                        if (nameA < nameB)
                                                            return -1;
                                                        if (nameA > nameB)
                                                            return 1;
                                                        return 0;
                                                    });
                                                    end = process(results);
                                                }
                                                else {
                                                    var results = [];
                                                    results = results.concat(results1);
                                                    results = results.concat(results2);
                                                    results = results.concat(results4);
                                                    results = results.concat(results5);
                                                    results = results.concat(results6);
                                                    results = results.concat(results7);
                                                    results = results.concat(results8);
                                                    results = results.concat(results9);
                                                    results = results.concat(results10);
                                                    results.sort(function (a, b) {
                                                        var nameA = (+a.split('>')[0]),
                                                            nameB = (+b.split('>')[0]);
                                                        if (nameA < nameB)
                                                            return -1;
                                                        if (nameA > nameB)
                                                            return 1;
                                                        return 0;
                                                    });
                                                    end = process(results);
                                                }
                                            });
                                }
                                // }
                                return end;
                            }, 1000);

                        },
                        afterSelect: function (evt, item) {
                            let wait = setInterval(function () {
                                if (window.updater_resolved) {
                                    setTimeout(function () {
                                        $(id).typeahead('close');
                                        $(id + ':visible').blur();
                                    }, 100);
                                    $(btn).click();
                                    clearInterval(wait);
                                }
                            });
                        },
                        highlighter: function (item) {
                            const countrySplit = item.split('||');
                            if (countrySplit.length) {
                                $window.country_code = countrySplit[1];
                                item = countrySplit[0] + countrySplit[2];
                            }

                            if (!item) {
                                return item;
                            } else if (item.indexOf('loading') > -1) {
                                item = $translate.instant('search_loading');
                            } else if (item.indexOf('notfound') > -1) {
                                item = $translate.instant('search_notfound');
                            } else if (item.indexOf('error') > -1) {
                                item = $translate.instant('search_tryagain');
                            } else if (item.indexOf('|mahalle|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|mahalle|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-neighbourhood pull-right item-label">' + $translate.instant('search_district') + '</span>';
                                } else item = null;
                            }
                            else if (item.indexOf('|ilce|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|ilce|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-county pull-right item-label">' + $translate.instant('search_county') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|vilayet|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|vilayet|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-city pull-right item-label">' + $translate.instant('search_city') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|sokak|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|sokak|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-avenue pull-right item-label">' + $translate.instant('search_street') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|konut|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|konut|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-house pull-right item-label">' + $translate.instant('search_property') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|site|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|site|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-residencia-avm pull-right item-label">' + $translate.instant('search_gated') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|proje|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|proje|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-housing-project pull-right item-label">' + $translate.instant('search_project') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|avm|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|avm|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-housing-project pull-right item-label">' + $translate.instant('search_mall') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|country|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|country|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-country pull-right item-label">' + $translate.instant('search_country') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|endeksa|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|endeksa|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-endeksa pull-right item-label">' + $translate.instant('search_archive') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|street|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|street|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-street pull-right item-label">' + $translate.instant('search_street') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|opport|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|opport|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-opport2 pull-right item-label">' + $translate.instant('search_listing') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|agent|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|agent|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-endeksa2 pull-right item-label">' + $translate.instant('search_agent') + '</span>';
                                } else item = null;
                            } else {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|other')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-location pull-right item-label">' + $translate.instant('search_address') + '</span>';
                                } else item = null;
                            }
                            if (item)
                                item = '<span class="item-address">' + item + '</span>';

                            console.log(undefined); //DO NOT DELETE BABEL COMPILER HACK
                            return item;
                        },
                        minLength: 3,
                        hint: true,
                        fitToElement: true,
                        matcher: function () {
                            if ($(id).val())
                                return true;
                            else
                                return false;
                        },
                        updater: function (item) {
                            $window.mallId = null;
                            $window.endeksaId = null;
                            $window.agentId = null;
                            $window.opportId = null;
                            $window.regionId = undefined;
                            $window.projectId = null;
                            $window.rememberProperty = null;
                            $window.selectedLocation = null;
                            $window.gatheredLocation = null;
                            $window.parcelRecord = null;

                            const countrySplit = item.split('||');
                            if (countrySplit.length) {
                                $window.country_code = countrySplit[1];
                                item = countrySplit[0] + countrySplit[2];

                                var country = $window.country_code === 'PT' || $window.country_code === 'Portugal' ? 'portugal' : $window.country_code === 'TR' ? 'turkiye' : $window.country_code === 'ES' ? 'espana' : 'world';
                                $rootScope.country = country;
                            }

                            if (item.indexOf('loading') > -1) {
                                item = "";
                            }
                            if (item.indexOf('notfound') > -1) {
                                item = "";
                            } else if (item.indexOf('error') > -1) {
                                item = '';
                            } else if (item.indexOf('|vilayet') > -1) {
                                $window.lastLevel = 1;
                            } else if (item.indexOf('|ilce') > -1) {
                                $window.lastLevel = 2;
                            } else if (item.indexOf('|mahalle') > -1) {
                                $window.lastLevel = 3;
                            } else if (item.indexOf('|semt') > -1) {
                                $window.lastLevel = 3;
                            } else if (item.indexOf('|sokak') > -1) {
                                $window.lastLevel = 0;
                            } else if (item.indexOf('|konut') > -1) {
                                $window.lastLevel = 0;
                            } else if (item.indexOf('|site') > -1) {
                                $window.lastLevel = 0;
                            } else if (item.indexOf('|proje') > -1) {
                                $window.lastLevel = 6;
                            } else if (item.indexOf('|street') > -1) {
                                //TODO: Street leveli düzeltip tekrar devreye alalım
                                $window.lastLevel = 5;
                            } else if (item.indexOf('|avm') > -1) {
                                $window.lastLevel = 7;
                            } else if (item.indexOf('|country') > -1) {
                                $window.lastLevel = 9;
                            } else if (item.indexOf('|region') > -1) {
                                $window.lastLevel = 11;
                            } else if (item.indexOf('|agent') > -1) {
                                $window.lastLevel = 2;
                            } else {
                                $window.lastLevel = 0;
                            }

                            item = item.split('>')[1];
                            if (item.indexOf('|proje|') > -1)
                                $window.projectId = +item.split('|proje|')[1].split('|l')[0];
                            else
                                $window.projectId = null;

                            if (item.indexOf('|avm|') > -1)
                                $window.mallId = +item.split('|avm|')[1].split('|l')[0];
                            else
                                $window.mallId = null;

                            if (item.indexOf('|endeksa|') > -1) {
                                $window.endeksaId = item.split('|endeksa|')[1].split('|l')[0];
                            } else
                                $window.endeksaId = null;

                            if (item.indexOf('|agent|') > -1) {
                                $window.agentId = item.split('|agent|')[1].split('|l')[0];
                            } else
                                $window.agentId = null;

                            if (item.indexOf('|opport|') > -1) {
                                $window.opportId = item.split('|opport|')[1].split('|l')[0];
                            } else
                                $window.opportId = null;

                            if (item.indexOf('|region|') > -1) {
                                $window.regionId = item.split('|region|')[1].split('|l')[0];
                            } else
                                $window.regionId = undefined;

                            try {
                                if (item.split('|l:')[1] !== 'NaN NaN' && item.split('|l:')[1] !== 'null' && item.split('|l:')[1] !== 'null null' && item.split('|l:')[1]) {
                                    var lat = item.split('|l:')[1].split(' ')[1];
                                    var lng = item.split('|l:')[1].split(' ')[0];
                                    if (lat - 40.965544 === 0) { //<= 0.002) {
                                        lat = lat - 0.061;
                                    }
                                    if (lng - 29.106000 === 0) { //} <= 0.002) {
                                        lng = lng + 0.000290;
                                    } else if (lng - 29.052037 === 0) {
                                        lng = lng - 0.01;
                                    }

                                    //yandexten gelen alanya merkez koordinatı bizdeki shapein dışında kalıyor.
                                    if (item.split('|')[0] === 'Alanya, Antalya') {
                                        lat = 36.5919877276;
                                        lng = 32.1493611265;
                                    }

                                    $window.selectedLocation = lng + ' ' + lat;
                                    $window.updater_resolved = true;
                                }
                                else if (item.split('|p:')[1] !== 'NaN NaN' && item.split('|p:')[1] !== 'null' && item.split('|p:')[1] !== 'null null' && item.split('|p:')[1]) {
                                    var place_id = item.split('|p:')[1].replace('undefined', '');
                                    var geocoder = new google.maps.Geocoder();
                                    geocoder
                                        .geocode({ placeId: place_id })
                                        .then(({ results }) => {
                                            $window.selectedLocation = results[0].geometry.location.lng() + ' ' + results[0].geometry.location.lat();
                                            $window.updater_resolved = true;
                                        });
                                }
                                else {
                                    $window.selectedLocation = null;
                                    $window.updater_resolved = true;
                                }
                                item = item.split('|mahalle')[0];
                                item = item.split('|semt')[0];
                                item = item.split('|vilayet')[0];
                                item = item.split('|ilce')[0];
                                item = item.split('|sokak')[0];
                                item = item.split('|konut')[0];
                                item = item.split('|site')[0];
                                item = item.split('|proje')[0];
                                item = item.split('|endeksa')[0];
                                item = item.split('|avm')[0];
                                item = item.split('|agent')[0];
                                item = item.split('|other')[0];
                                item = item.split('|country')[0];
                                item = item.split('|opport')[0];
                                item = item.split('|region')[0];
                                item = item.split('|street')[0];
                                $rootScope.address = item;

                                $window.searchHistory.setItem($rootScope.address, $window.selectedLocation, $window.lastLevel, $rootScope.country, $window.endeksaId, $window.opportId, $window.mallId, $window.projectId, $window.agentId, $window.regionId, $rootScope.selectedMethod);

                            } catch (err) {
                                $window.selectedLocation = null;
                                item = item.split('|other')[0];
                            }
                            return item;
                        }
                    });
                    // });
                });
            };

            $window.searchHistory = {
                list: [],
                setItem: function (item, location, level, country, endeksa, opportunity, mall, project, agent, region, method) {

                    if (typeof $window.fbq != "undefined")
                        try {
                            $window.fbq('track', 'Search');
                        } catch (err) { }

                    $window.dataLayer.push({
                        event: "search",
                        currency: window.currency,
                        language: window.lang.split('-')[0],
                        search_term: item
                    });

                    const log = { id: window.makeid(3), item: item, location: location, level: level, country: country, endeksa: endeksa, opportunity: opportunity, mall: mall, project: project, agent: agent, region: region, method: method };

                    $window.searchHistory.list.reverse();
                    $window.searchHistory.list.push(log);
                    if ($window.searchHistory.list.length > 3)
                        $window.searchHistory.list.shift();
                    $window.searchHistory.list.reverse();

                    $window.localStorage.removeItem('searchHistoryLogId');
                    $window.localStorage.setItem('searchHistoryLogId', JSON.stringify(window.searchHistory.list));

                    $rootScope.searchHistory = $window.searchHistory;

                },
                removeItem: function (item) {
                    var listItem = $window.searchHistory.list.find(m => m.item === item.item);
                    const index = $window.searchHistory.list.indexOf(listItem);
                    if (index > -1) {
                        $window.searchHistory.list.splice(index, 1);
                    }
                    $window.localStorage.removeItem('searchHistoryLogId');
                    $window.localStorage.setItem('searchHistoryLogId', JSON.stringify(window.searchHistory.list));
                    if ($window.searchHistory.list.length)
                        $timeout(function () {
                            $rootScope.searchFocused = 1;
                        }, 301);

                    $rootScope.searchHistory = $window.searchHistory;

                },
                sync: function () {
                    var list = $window.localStorage.getItem('searchHistoryLogId');
                    $window.searchHistory.list = JSON.parse(list) || [];
                },
                goTo: function (item) {
                    $window.updater_resolved = true;
                    $window.selectedLocation = item.location;
                    $window.gatheredLocation = null;
                    $window.lastLevel = item.level;
                    $window.endeksaId = item.endeksa;
                    $window.opportId = item.opportunity;
                    $window.mallId = item.mall;
                    $window.projectId = item.project;
                    $window.agentId = item.agent;
                    $window.regionId = item.region;
                    $rootScope.selectedMethod = item.method ? item.method : 1;
                    $rootScope.address = item.item;
                    $rootScope.country = item.country;
                    $rootScope.parserSearchfromInputTop($rootScope.selectedMethod);

                    $rootScope.searchHistory = $window.searchHistory;

                }
            };
            $window.searchHistory.sync();
            $rootScope.searchHistory = $window.searchHistory;


            // $rootScope.openReportCalendar = function () {
            //     ngDialog.open({
            //         templateUrl: $window.lang === 'tr' ? 'app/shell/calendar-report.html' : 'app/shell/calendar-english.html',
            //         overlay: true,
            //         closeByEscape: true,
            //         showClose: false,
            //         closeByNavigation: true,
            //         closeByDocument: true,
            //         controller: ['$scope', 'userSvc', function ($scope, userSvc) {
            //             if (userSvc.info.SignedIn)
            //                 userSvc.getUserInfo().then(function (account) {
            //                     $scope.account = account.information;
            //                 });
            //             else
            //                 $scope.account = { profile: {} };
            //         }]
            //     });
            // };

            // $rootScope.openAdvanceCalendar = function () {
            //     ngDialog.open({
            //         templateUrl: $window.lang === 'tr' ? 'app/shell/calendar-advance.html' : 'app/shell/calendar-english.html',
            //         overlay: true,
            //         closeByEscape: true,
            //         showClose: false,
            //         closeByNavigation: true,
            //         closeByDocument: true,
            //         controller: ['$scope', 'userSvc', function ($scope, userSvc) {
            //             if (userSvc.info.SignedIn)
            //                 userSvc.getUserInfo().then(function (account) {
            //                     $scope.account = account.information;
            //                 });
            //             else
            //                 $scope.account = { profile: {} };
            //         }]
            //     });
            // };

            $rootScope.isIntercomVisible = function () {
                return angular.element('.intercom-messenger-frame').length;
            };

            $rootScope.leadModal = function () {
                ngDialog.open({
                    templateUrl: 'app/shell/lead-modal.html',
                    overlay: true,
                    closeByEscape: true,
                    showClose: false,
                    closeByNavigation: true,
                    closeByDocument: true,
                    controller: ['$scope', 'consultancy_factory', 'notifierSvc', '$translate', '$window', function ($scope, consultancy_factory, notifierSvc, $translate, $window) {
                        $scope.hideClose = false;
                        $scope.contact = {
                            name: "",
                            phone: "",
                            sent: false,
                        };
                        $scope.acikRiza = function () {
                            ngDialog.open({
                                templateUrl: 'app/content/sozlesme/mortgage-riza-modal.html'
                            });
                        };
                        // provinceListService.getProvinces().then(function (response) { $scope.Cities = response.List; });

                        // $scope.isConsultancy = $state.current.name.indexOf('danisman') > -1;

                        // $scope.loadCounties = function () {
                        //     $scope.contact.county = null;
                        //     $scope.contact.district = null;
                        //     provinceListService.CountiesOfProvince($scope.contact.city.CityId).then(function (response) { $scope.Counties = response.List; });
                        // };
                        // $scope.loadDistricts = function () {
                        //     if ($scope.contact.city && $scope.contact.county) {
                        //         $scope.contact.district = null;
                        //         provinceListService.NeighbourhoodsOfCounty($scope.contact.city.CityId, $scope.contact.county.CountyId).then(function (response) { $scope.Districts = response.List; });
                        //     }
                        // };
                        $scope.hideMenu = function () {
                            $("#mobile-menu").hide();
                            $scope.closeThisDialog();
                        };

                        // Captcha state
                        $scope.ETToken = null;
                        $scope.captchaVerified = false;
                        $scope.isTurkishPhone = true;
                        $scope.eimageCaptchaKey = null;
                        $scope.eimageCaptchaValue = null;

                        $scope.contact = {
                            name: "",
                            surname: "",
                            phone: "",
                            sent: false,
                            privacy: false,
                            consultancyType: 10,
                            agentId: agent.Id,
                            agentName: agent.Name,
                            agentSurname: agent.Surname
                        };

                        $scope.call = function () {
                            if ($scope.contact.phone < 13 || !$scope.contact.name || !$scope.contact.privacy || agent.Id === user.Id)
                                return false;
                            $scope.closeThisDialog();
                            $("#mobile-menu").hide();
                            consultancy_factory
                                .post($scope.contact)
                                .$promise.then(function () {
                                    var recieved = $translate.instant('realtors_recieved');
                                    notifierSvc.show({ title: $translate.instant('consult_title'), message: recieved, type: 'success' });
                                    $scope.contact = {
                                        name: "",
                                        surname: "",
                                        phone: "",
                                        sent: false,
                                        consultancyType: 10,
                                        agentId: agent.Id,
                                        agentName: agent.Name,
                                        agentagentSurname: agent.Surname
                                    };
                                });
                        };


                        // $scope.call = function () {
                        //     if ($scope.contact.phone < 13 || !$scope.contact.name || !$scope.contact.privacy)
                        //         return false;
                        //     $scope.closeThisDialog();
                        //     $("#mobile-menu").hide();
                        //     // var content =
                        //     //     ' <br> ' +
                        //     //     $scope.contact.name +
                        //     //     ' <br> ' +
                        //     //     $scope.contact.phone +
                        //     //     // ' <br> ' +
                        //     //     // ($scope.contact.city ? $scope.contact.city.CityName : "") + ' ' + ($scope.contact.county ? $scope.contact.county.CountyName : "") + ' ' + ($scope.contact.district ? $scope.contact.district.DistrictName : "") +
                        //     //     ' <br> Yardım İstediğim Konu: ' + $scope.contact.type +
                        //     //     ' <br> Bulunduğu Sayfa: ' + $window.location.href;

                        //     // var url = '';
                        //     // if ($scope.contact.city && $scope.contact.county && $scope.contact.district)
                        //     //     url = ' <br>https://www.endeksa.com/tr/analiz/' + normalizeAddress($scope.contact.city.CityName) + '/' + normalizeAddress($scope.contact.county.CountyName) + '/' + normalizeAddress($scope.contact.district.DistrictName) + '/endeks/satilik/konut';
                        //     // else if ($scope.contact.city && $scope.contact.county)
                        //     //     url = ' <br>https://www.endeksa.com/tr/analiz/' + normalizeAddress($scope.contact.city.CityName) + '/' + normalizeAddress($scope.contact.county.CountyName) + '/endeks/satilik/konut';
                        //     // else if ($scope.contact.city)
                        //     //     url = ' <br>https://www.endeksa.com/tr/analiz/' + normalizeAddress($scope.contact.city.CityName) + '/endeks/satilik/konut';
                        //     // else
                        //     //     url = ' <br>https://www.endeksa.com/tr/analiz/turkiye/endeks/satilik/konut';

                        //     // content = content + url;
                        //     // var title = 'Arkadaşımı Öneriyorum';
                        //     // leadAPI
                        //     //     .set({
                        //     //         Email: 'referral@endeksa.com',
                        //     //         Source: 'Arkadaşımı Öneriyorum',
                        //     //         Content: [{ Value: content, Title: title }]
                        //     //     })
                        //     //     .$promise.then(function () {
                        //     //         var recieved = $translate.instant('realtors_recieved');
                        //     //         notifierSvc.show({ title: $translate.instant('consult_title'), message: recieved, type: 'success' });
                        //     //         $scope.contact = {
                        //     //             name: "",
                        //     //             phone: "",
                        //     //             sent: false,
                        //     //             city: null,
                        //     //             county: null,
                        //     //             district: null,
                        //     //             type: "Satmak"
                        //     //         };
                        //     //     });
                        // };
                    }]
                });
            };

            // if ($location.search().lead) {
            //     $rootScope.callRealtor();
            // }

            $rootScope.Number = Number;

            var iframeOpen, tns_wrapper;
            $rootScope.frameModal = function (url, list, proper, tab, small, scale, user, startIndex) {
                if (!iframeOpen || !ngDialog.isOpen(iframeOpen.id)) {
                    iframeOpen = ngDialog.open({
                        templateUrl: 'app/shell/iframe.html',
                        overlay: true,
                        closeByEscape: true,
                        showClose: false,
                        closeByNavigation: true,
                        closeByDocument: true,
                        preCloseCallback: function () {
                            if (tns_wrapper && tns_wrapper.events) {
                                tns_wrapper.destroy();
                                iframeOpen = null;
                            }
                        },
                        className: 'ngdialog-theme-default iframe-dialog',
                        controller: ['$scope', '$timeout', function ($scope, $timeout) {
                            if (proper) {
                                $scope.property = proper; // property data
                                if (proper.Images)
                                    proper.Images = proper.Images.filter(p => p !== '');
                                else if (proper.Photos)
                                    proper.Photos = proper.Photos.filter(p => p !== '');
                            }

                            $scope.small = small;
                            $scope.scale = scale;
                            $scope.tabSelected = tab ? tab : 1;
                            if (!proper || (proper.Images && proper.Images.length == 0) || (proper.Photos && proper.Photos.length == 0))
                                $scope.tabSelected = 2;
                            $scope.url = url;
                            $scope.itlist = list;
                            $scope.startIndex = startIndex !== undefined ? startIndex : 0; // Store start index for carousel

                            function transitionEnd() {
                                var totalItems = $('.tns-indicators li').length;
                                var currentIndex = $('.tns-indicators li.tns-nav-active').index() + 1;
                                $('.carousel-trad .image-count span').html('' + currentIndex + '/' + totalItems + '');
                            }

                            $scope.changeTab = function (tab) {
                                $scope.tabSelected = tab;

                                if (tab == 1)
                                    $ocLazyLoad.load("/assets/js/tiny-slider.js?v=" + $window.appVersion).then(function () {
                                        $timeout(function () {
                                            var initialIndex = $scope.startIndex || 0;
                                            tns_wrapper = tns({
                                                container: '.image-tns',
                                                items: 1,
                                                slideBy: 1,
                                                autoplay: false,
                                                autoWidth: false,
                                                loop: true,
                                                rewind: false,
                                                gutter: 0,
                                                swipeAngle: 15,
                                                preventScrollOnTouch: 'auto',
                                                nav: true,
                                                navContainer: '.tns-indicators',
                                                lazyload: true,
                                                controlsContainer: '.tns-ctrl-image',
                                                prevButton: '.tns-ctrl-image .left',
                                                nextButton: '.tns-ctrl-image .right',
                                                startIndex: initialIndex
                                            });
                                            tns_wrapper.events.on('transitionEnd', transitionEnd);
                                            // Broadcast on index change for carousel sync
                                            tns_wrapper.events.on('indexChanged', function (info) {
                                                $timeout(function () {
                                                    $rootScope.$broadcast('modal:carouselIndexChanged', {
                                                        index: info.index,
                                                        displayIndex: info.displayIndex
                                                    });
                                                }, 0);
                                            });
                                        });
                                    });
                            };


                            const plainPhone = user ? user.phoneNumber : proper.UserInfo.UserTel;

                            $scope.phoneFormated = $window.phoneFormat(plainPhone, proper ? proper.CountryId : null);
                            if ($scope.phoneFormated && proper) {
                                $scope.phoneHidden = $scope.phoneFormated.slice(0, 7);
                            }


                            $scope.userAgent = user ? user.officeName : proper.UserInfo.UserAgent;
                            $scope.userName = user ? user.name : proper.UserInfo.UserName;
                            $scope.userSurname = user ? user.surName : proper.UserInfo.UserSurname;
                            $scope.userLogo = user ? user.logoUrl : proper.UserInfo.UserLogo;
                            $scope.userAvatar = user ? user.avatarUrl : null;
                            $scope.userSlogan = user ? user.userSlogan : null;

                            $scope.showNumber = false;
                            $scope.show = function () {
                                userview_factory.post({ userId: { value: proper.UserId }, Phone: plainPhone }).$promise.then(function () {
                                    $scope.showNumber = true;
                                }, function () {
                                    $scope.showNumber = true;
                                });
                                $window.dataLayer.push({
                                    event: "select_content",
                                    currency: window.currency,
                                    language: window.lang.split('-')[0],
                                    content_type: "agent",
                                    item_id: proper.UserId,
                                    item_name: $scope.userName + ' ' + $scope.userSurname
                                });
                                // $window.gtag("event", "select_content", {
                                //     content_type: "agent",
                                //     item_id: proper.UserId,
                                //     item_name: $scope.userName + ' ' + $scope.userSurname
                                // });
                            };

                            $scope.updateDate = proper.UpdateDate;

                            if (proper.OwnerName) {
                                $scope.ownerName = proper.OwnerName.split(' Danışman :')[0];
                                $scope.ownerAgent = proper.OwnerName.split(' Danışman :')[1];
                                $scope.ownerLogo = proper.OwnerLogo;
                            }

                            $ocLazyLoad.load("/assets/js/tiny-slider.js?v=" + $window.appVersion).then(function () {
                                $timeout(function () {
                                    var totalItems = $('.tns-indicators li').length;
                                    var initialIndex = $scope.startIndex || 0;
                                    $('.carousel-trad .image-count span').html((initialIndex + 1) + '/' + totalItems + '');
                                    tns_wrapper = tns({
                                        container: '.image-tns',
                                        slideBy: 1,
                                        autoplay: true,
                                        autoplayHoverPause: true,
                                        autoplayButton: false,
                                        autoplayButtonOutput: false,
                                        autoWidth: false,
                                        loop: false,
                                        rewind: true,
                                        gutter: 15,
                                        nav: true,
                                        swipeAngle: false,
                                        navContainer: '.tns-indicators',
                                        lazyload: true,
                                        controlsContainer: '.tns-ctrl-image',
                                        prevButton: '.tns-ctrl-image .left',
                                        nextButton: '.tns-ctrl-image .right',
                                        startIndex: initialIndex
                                    });
                                    tns_wrapper.events.on('transitionEnd', transitionEnd);
                                    // Broadcast on index change for carousel sync
                                    tns_wrapper.events.on('indexChanged', function (info) {
                                        $timeout(function () {
                                            $rootScope.$broadcast('modal:carouselIndexChanged', {
                                                index: info.index,
                                                displayIndex: info.displayIndex
                                            });
                                        }, 0);
                                    });
                                }, 100);
                            });
                            // listing site
                            $scope.goToListingSite = function (url) {
                                $window.PopupCenter(url, 'İlan', $window.innerWidth * 0.8, $window.innerHeight * 0.9);
                            };
                        }]
                    });
                }
            };

            $rootScope.isNumber = function (number) {
                if (number && $window.isFinite(number) && +number !== 0)
                    return true;
                return false;
            };

            $window.phoneFormat = function (phone, country) {
                if (!phone) return '';
                let countryCode;
                switch (country) {
                    case 1:
                        countryCode = 'TR';
                        break;
                    case 2:
                        countryCode = 'ES';
                        break;
                    case 3:
                        countryCode = 'PT';
                        break;
                    default:
                        countryCode = 'TR';
                }
                let isValid = window.libphonenumber.isValidPhoneNumber(phone, countryCode);
                if (isValid)
                    return window.libphonenumber.parsePhoneNumber(phone, countryCode).formatInternational();
                else return '';
                /* const countryCode = country === 3 ? '+351' : country === 2 ? '+34' : '+90';
                if (phone && phone.toString().charAt(0) !== "0" && phone.toString().charAt(0) !== "+")
                    phone = countryCode + phone;
                else if (phone && phone.toString().charAt(0) === "0")
                    phone = "+9" + phone;

                phone = phone ? phone.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "") : null;

                phone = phone ? "+" + phone.split(',')[0].split('+')[1] : phone;

                if (phone && country === 2) {
                    return phone.replace(/^(.{3})(.{3})(.{3})(.{3})(.*)$/, "$1 $2 $3 $4 $5");
                }
                else if (phone && country === 3) {
                    return phone.replace(/^(.{4})(.{3})(.{3})(.{3})(.*)$/, "$1 $2 $3 $4 $5");
                }
                else if (phone) {
                    return phone.replace(/^(.{3})(.{3})(.{3})(.{2})(.*)$/, "$1 $2 $3 $4 $5");
                }
                else {
                    return phone;
                } */
            };
            $rootScope.phoneFormat = $window.phoneFormat;

            $rootScope.history = function (alarm) {
                $rootScope.historyList = [];
                $rootScope.historyLoading = true;
                ngDialog.open({
                    templateUrl: "app/bolgesel-analiz/views/alarm-history.html",
                    scope: $rootScope,
                    overlay: true,
                    closeByEscape: false,
                    showClose: false,
                    closeByNavigation: false,
                    disableAnimation: true,
                    closeByDocument: false,
                    controller: [
                        "$scope",
                        function ($scope) {
                            $scope.alarmItem = alarm;
                            valuationGETAPI.comparables({
                                EndeksaId: alarm.EndeksaId,
                                /* propertycategory: alarm.PropertyCategory,
                                countryid: alarm.CountryId */
                            })
                                .$promise.then(function (list) {
                                    if (list.History.length > 0) {
                                        $rootScope.historyList = list.History;
                                    } else {
                                        $rootScope.historyList = [{ ListingActive: alarm.ListingActive, Price: alarm.RealtyPrice, Date: alarm.CreateDate }];
                                    }
                                    $rootScope.historyLoading = false;
                                });
                        },
                    ],
                });
            };

            $rootScope.usageStatusList = function (comparable) {
                switch (comparable.UsageStatus) {
                    case 1:
                        return $translate.instant('usage_owner');
                    case 2:
                        return $translate.instant('usage_tenant');
                    case 3:
                        return $translate.instant('step2_empty');
                    default:
                        return '';
                }
            };

            $rootScope.comparablesModal = function (comparable) {
                if (!comparable.CurrencyId && comparable.Currency)
                    comparable.CurrencyId = comparable.Currency;
                comparablesApi.detail({ EndeksaId: comparable.EndeksaId, captchaTokenCustom: window.ecSec() }).$promise.then(function (result) {
                    $rootScope.currentComparable = result;
                }, function () {
                    $rootScope.currentComparable = comparable;
                }).finally(() => {
                    if (!iframeOpen || !ngDialog.isOpen(iframeOpen.id)) {
                        iframeOpen = ngDialog.open({
                            templateUrl: 'app/shell/comparables-modal.html',
                            overlay: true,
                            closeByEscape: true,
                            showClose: false,
                            closeByNavigation: true,
                            closeByDocument: true,
                            preCloseCallback: function () {
                                if (tns_wrapper && tns_wrapper.events) {
                                    tns_wrapper.destroy();
                                }
                            },
                            className: 'ngdialog-theme-default iframe-dialog',
                            controller: ['$scope', '$timeout', function ($scope, $timeout) {
                                $ocLazyLoad.load("/assets/js/tiny-slider.js?v=" + $window.appVersion).then(function () {
                                    $timeout(function () {
                                        tns_wrapper = tns({
                                            container: '.comparable-tns',
                                            autoWidth: false,
                                            loop: false,
                                            rewind: true,
                                            nav: true,
                                            swipeAngle: false,
                                            navContainer: '.tns-indicators',
                                            controlsContainer: '.tns-ctrl-comparable',
                                            prevButton: '.tns-ctrl-comparable .left',
                                            nextButton: '.tns-ctrl-comparable .right'
                                        });
                                        tns_wrapper.events.on('transitionEnd', transitionEnd);
                                        $('#comparable-modal').scrollTop(0, 0);
                                        $window.scrollTo(0, 0);
                                    }, 100);
                                });
                                function transitionEnd() {
                                    var totalItems = $('.tns-indicators li').length;
                                    var currentIndex = $('.tns-indicators li.tns-nav-active').index() + 1;
                                    $('.carousel-wrapper .image-count span').html('' + currentIndex + '/' + totalItems + '');
                                }


                                $scope.formatPhone = function (phone) {
                                    return $window.phoneFormat(phone, $scope.currentComparable.CountryId);
                                };

                                $scope.getPriceType = function () {
                                    if (!angular.isString($scope.currentComparable.PropertyPriceTypeId))
                                        return $scope.currentComparable.PropertyPriceTypeId === 1 ? $translate.instant("value_filter_model_1") : $translate.instant("value_filter_model_2");
                                    return $scope.currentComparable.PropertyPriceType.toLocaleProperCase2();
                                };

                                $scope.getFrontage = function () {
                                    let frontages = [];
                                    if ($scope.currentComparable.FrontageEast)
                                        frontages.push($translate.instant("frontage_east"));
                                    if ($scope.currentComparable.FrontageWest)
                                        frontages.push($translate.instant("frontage_west"));
                                    if ($scope.currentComparable.FrontageSouth)
                                        frontages.push($translate.instant("frontage_south"));
                                    if ($scope.currentComparable.FrontageNorth)
                                        frontages.push($translate.instant("frontage_north"));

                                    return frontages;
                                };



                                $rootScope.viewData = $rootScope.getCompViewData($rootScope.currentComparable);
                                $rootScope.attrData = $rootScope.getCompAttrData($rootScope.currentComparable);






                            }]
                        });
                    }
                });


            };



            function heatingSystemList() {
                return [
                    {
                        label: $translate.instant('propertyHeatingNone'),
                        value: 10
                    },
                    {
                        label: $translate.instant('propertyHeatingStove'),
                        value: 20
                    },
                    {
                        label: $translate.instant('propertyHeatingGasNatural'),
                        value: 30
                    },
                    {
                        label: $translate.instant('propertyHeatingHeater'),
                        value: 40
                    },
                    {
                        label: $translate.instant('propertyHeatingCombi'),
                        value: 50
                    },
                    {
                        label: $translate.instant('propertyHeatingCentral'),
                        value: 60
                    },
                    {
                        label: $translate.instant('propertyHeatingMeater'),
                        value: 70
                    },
                    {
                        label: $translate.instant('propertyHeatingFloor'),
                        value: 80
                    },
                    {
                        label: $translate.instant('propertyHeatingAirConditioner'),
                        value: 90
                    },
                    {
                        label: $translate.instant('propertyHeatingGeo'),
                        value: 100
                    },
                    {
                        label: $translate.instant('propertyHeatingSolar'),
                        value: 110
                    },
                    {
                        label: $translate.instant('VRF'),
                        value: 130
                    },
                    {
                        label: $translate.instant('FanCoil'),
                        value: 140
                    },
                    {
                        label: $translate.instant('Akaryakıt'),
                        value: 150
                    },
                    {
                        label: $translate.instant('Elektrik'),
                        value: 160
                    },
                    {
                        label: $translate.instant('Propan/Butan Gazı'),
                        value: 170
                    },
                    {
                        label: $translate.instant('list_other'),
                        value: 120
                    }
                ];
            }

            $rootScope.getCompAttrData = (comparable) => {
                const attributes = comparable.Attributes;
                let attrList;
                if (!attributes || !attributes.length) attrList = [];

                attrList = [
                    {
                        label: $translate.instant('propertyPossMainRoad'),
                        value: attributes.find((x) => x === 10) || false,
                        icon: 'listing-road'
                    },
                    {
                        label: $translate.instant('Cadde Üzerinde'),
                        value: attributes.find((x) => x === 15) || false,
                        icon: 'listing-wideroad'
                    },
                    {
                        label: $translate.instant('in_complex'),
                        value: attributes.find((x) => x === 20) || false,
                        icon: 'apartment'
                    },
                    {
                        label: $translate.instant('propertyPossSport'),
                        value: attributes.find((x) => x === 30) || false,
                        icon: 'listing-gym'
                    },
                    {
                        label: $translate.instant('Çocuk Oyun Parkı'),
                        value: attributes.find((x) => x === 40) || false,
                        icon: 'listing-playground'
                    },
                    {
                        label: $translate.instant('elevator'),
                        value: attributes.find((x) => x === 50) || false,
                        icon: 'listing-elevator'
                    },
                    {
                        label: $translate.instant('propertyPossGenerator'),
                        value: attributes.find((x) => x === 60) || false,
                        icon: 'listing-generator'
                    },
                    {
                        label: $translate.instant('propertyPossBuilding'),
                        value: attributes.find((x) => x === 70) || false,
                        icon: 'listing-gatekeeper'
                    },
                    {
                        label: $translate.instant('security'),
                        value: attributes.find((x) => x === 80) || false,
                        icon: 'listing-security'
                    },
                    {
                        label: $translate.instant('propertyPossOutDoor'),
                        value: attributes.find((x) => x === 90) || false,
                        icon: 'listing-parking'
                    },
                    {
                        label: $translate.instant('indoor_parking'),
                        value: attributes.find((x) => x === 100) || false,
                        icon: 'listing-garage'
                    },
                    {
                        label: $translate.instant('indoor_pool'),
                        value: attributes.find((x) => x === 110) || false,
                        icon: 'listing-indoorpool'
                    },
                    {
                        label: $translate.instant('Havuz'),
                        value: attributes.find((x) => x === 120) || false,
                        icon: 'listing-pool'
                    },
                    {
                        label: $translate.instant('Isı Yalıtımı'),
                        value: attributes.find((x) => x === 130) || false,
                        icon: 'listing-wall'
                    },
                    {
                        label: $translate.instant('Klima'),
                        value: attributes.find((x) => x === 150) || false,
                        icon: 'listing-heating'
                    },
                    {
                        label: $translate.instant('Şömine'),
                        value: attributes.find((x) => x === 155) || false,
                        icon: 'listing-fireplace'
                    },
                    {
                        label: $translate.instant('Elektrik'),
                        value: attributes.find((x) => x === 170) || false,
                        icon: 'listing-generator'
                    },
                    {
                        label: $translate.instant('Su'),
                        value: attributes.find((x) => x === 175) || false,
                        icon: 'listing-water'
                    },
                    {
                        label: $translate.instant('Yolu Açık'),
                        value: attributes.find((x) => x === 180) || false,
                        icon: 'listing-open-road'
                    },
                    {
                        label: $translate.instant('Köşe Parsel'),
                        value: attributes.find((x) => x === 185) || false,
                        icon: 'listing-corner'
                    },
                    {
                        label: $translate.instant('İfraz Görmüş'),
                        value: attributes.find((x) => x === 190) || false,
                        icon: 'listing-divide'
                    },
                    {
                        label: $translate.instant('Denize Sıfır'),
                        value: attributes.find((x) => x === 195) || false,
                        icon: 'listing-lake'
                    },
                    {
                        label: $translate.instant('Denize Yakın'),
                        value: attributes.find((x) => x === 200) || false,
                        icon: 'listing-lake'
                    },
                    {
                        label: $translate.instant('Toplu Ulaşıma Yakın'),
                        value: attributes.find((x) => x === 201) || false,
                        icon: 'transportation'
                    },
                    {
                        label: $translate.instant('Havaalanına Yakın'),
                        value: attributes.find((x) => x === 202) || false,
                        icon: 'listing-airport'
                    },
                    {
                        label: $translate.instant('Doğalgaz Altyapısı'),
                        value: attributes.find((x) => x === 210) || false,
                        icon: 'listing-gas'
                    },
                    {
                        label: $translate.instant('p_telephone'),
                        value: attributes.find((x) => x === 220) || false,
                        icon: 'phone'
                    },
                    {
                        label: $translate.instant('drain'),
                        value: attributes.find((x) => x === 230) || false,
                        icon: 'listing-sewer'
                    },
                    {
                        label: $translate.instant('ground_survey'),
                        value: attributes.find((x) => x === 240) || false,
                        icon: 'listing-survey'
                    },
                    {
                        label: $translate.instant('close_to_the_road'),
                        value: attributes.find((x) => x === 250) || false,
                        icon: 'listing-open-road'
                    },
                    {
                        label: $translate.instant('Sokak Üzerinde'),
                        value: attributes.find((x) => x === 260) || false,
                        icon: 'listing-open-road'
                    },
                    {
                        label: $translate.instant('Denizle İlişkisi Yok'),
                        value: attributes.find((x) => x === 270) || false,
                        icon: 'listing-lake'
                    },
                    {
                        label: $translate.instant('Hidrofor'),
                        value: attributes.find((x) => x === 280) || false,
                        icon: 'listing-pump'
                    },
                    {
                        label: $translate.instant('Su Deposu'),
                        value: attributes.find((x) => x === 290) || false,
                        icon: 'listing-watertank'
                    },
                    {
                        label: $translate.instant('Hırsız Alarmı'),
                        value: attributes.find((x) => x === 300) || false,
                        icon: 'listing-alarm'
                    },
                    {
                        label: $translate.instant('Yangın Alarmı'),
                        value: attributes.find((x) => x === 310) || false,
                        icon: 'listing-sensor-fire'
                    },
                    {
                        label: $translate.instant('İnternet Altyapısı'),
                        value: attributes.find((x) => x === 320) || false,
                        icon: 'listing-home-internet'
                    },
                    {
                        label: $translate.instant('Yangın Merdiveni'),
                        value: attributes.find((x) => x === 330) || false,
                        icon: 'listing-stairs'
                    },
                    {
                        label: $translate.instant('Güvenlik Kamerası'),
                        value: attributes.find((x) => x === 340) || false,
                        icon: 'listing-cctv'
                    },
                    {
                        label: $translate.instant('TV-Uydu Altyapısı'),
                        value: attributes.find((x) => x === 350) || false,
                        icon: 'listing-tv'
                    },
                    {
                        label: $translate.instant('Yeşil Alan'),
                        value: attributes.find((x) => x === 360) || false,
                        icon: 'listing-park'
                    },
                    {
                        label: $translate.instant('Balkon'),
                        value: attributes.find((x) => x === 370) || false,
                        icon: 'listing-balcony'
                    }
                ];

                const heatType = heatingSystemList().find(
                    (i) => i.value === comparable.HeatType || i.value === comparable.Heating
                );

                if (heatType)
                    attrList.push({
                        label: heatType.label,
                        value: heatType.value,
                        icon: 'listing-isolation'
                    });

                if (comparable.UsageStatus) {
                    attrList.push({
                        label: $rootScope.usageStatusList(comparable),
                        value: 1,
                        icon: 'tenant'
                    });
                }

                return attrList;
            };

            $rootScope.getCompViewData = function (comparable) {
                const views = comparable.Views;
                if (!views || !views.length) return [];

                return [
                    {
                        label: $translate.instant('Şehir Manzarası'),
                        value: views.find((x) => x === 50) || false,
                        icon: 'listing-city'
                    },
                    {
                        label: $translate.instant('Doğa Manzarası'),
                        value: views.find((x) => x === 60) || false,
                        icon: 'listing-nature'
                    },
                    {
                        label: $translate.instant('Göl Manzarası'),
                        value: views.find((x) => x === 70) || false,
                        icon: 'listing-lake'
                    },
                    {
                        label: $translate.instant('Deniz Manzarası'),
                        value: views.find((x) => x === 80) || false,
                        icon: 'listing-sea'
                    },
                    {
                        label: $translate.instant('Boğaz'),
                        value: views.find((x) => x === 90) || false,
                        icon: 'listing-bridge'
                    }
                ];


            };

            $rootScope.getFromWho = function (id) {
                switch (id) {
                    case -1:
                        return 'Endeksa ' + $translate.instant('layout_menu51');
                    case 1:
                        return $translate.instant('list_owner2');
                    case 2:
                        return $translate.instant('list_agent');
                    case 4:
                        return $translate.instant('list_bank');
                    case 3:
                        return $translate.instant('list_company');
                    default:
                        return $translate.instant('list_other');
                }
            };

            /* $rootScope.getCompPhoneList = function (item) {
                if (item.OwnerTel)
                    if (!angular.isObject(item.OwnerTel) && item.OwnerTel.indexOf(', ') > -1)
                        return item.OwnerTel.split(', ');
                    else if (!angular.isObject(item.OwnerTel) && item.OwnerTel.match(/\+/g) && item.OwnerTel.match(/\+/g).length > 1)
                        return item.OwnerTel.split(' ');
                    else if (angular.isObject(item.OwnerTel)) {
                        return item.OwnerTel;
                    }
                return [item.OwnerTel];
            }; */

            $rootScope.getPropertyTypeName = function (id) {
                switch (id) {
                    //Konut
                    case 1:
                        return 'Müstakil Ev';
                    case 2:
                    case 10000201:
                        return 'Apartman Dairesi';

                    //Ticari
                    case 10000202:
                        return 'value_filter_ofis_imalat';
                    case 10000203:
                        return 'AVM';
                    case 10000204:
                        return 'Komple Bina';
                    case 10000205:
                        return 'Depo & Antrepo';
                    case 10000206:
                        return 'Dükkan & Mağaza';
                    case 10000207:
                        return 'value_filter_ofis_fabrika';
                    case 10000208:
                        return 'Genel';
                    case 10000209:
                        return 'Sağlık Merkezi';
                    case 10000211:
                        return 'İş Hanı Katı & Ofisi';
                    case 10000212:
                        return 'Tatil Köyü';
                    case 10000213:
                        return 'Kaplıca Tesisi';
                    case 10000214:
                        return 'Büro & Ofis';
                    case 10000215:
                        return 'Plaza Katı & Ofisi';
                    case 10000216:
                        return 'Komple Plaza';
                    case 10000217:
                        return 'Müstakil İşyeri';
                    case 10000219:
                        return 'Turistik İşletme';
                    case 10000222:
                        return 'Eczane & Medikal';
                    case 10000223:
                        return 'Taksi Durağı';
                    case 10000224:
                        return 'Pazar Yeri';
                    case 10000226:
                        return 'Villa Katı';
                    case 10000227:
                        return 'value_filter_ofis_otel';
                    case 10000228:
                        return 'Benzin İstasyonu';
                    case 10000229:
                        return 'value_filter_ofis_mulk';
                    case 10000231:
                        return 'Büfe & Market';
                    case 10000303:
                    case 10000232:
                        return 'Çiftlik';
                    case 10000233:
                        return 'Yeme & İçme';
                    case 10000234:
                        return 'Yurt & Pansiyon';
                    case 10000235:
                        return 'Kamp Yeri (Mocamp)';

                    //Arsa & Tarla
                    case 10:
                        return 'value_filter_land4';
                    case 20:
                        return 'Tarla';
                    case 30:
                        return 'Zeytinlik';
                    case 40:
                        return 'Tarla, Bağ, Bahçe';
                    case 50:
                        return 'Konut';
                    case 60:
                        return 'Villa İmarlı';
                    case 70:
                        return 'Konut İmarlı';
                    case 10000304:
                        return 'Depo, Antrepo İzinli';
                    case 10000305:
                        return 'Hastane (Sağlık Tesisi)';
                    case 10000307:
                        return 'Sanayi İmarlı';
                    case 10000308:
                        return 'ticariimar';
                    case 10000309:
                        return 'Konut + Ticari';
                    case 10000310:
                        return 'Maden Ocağı';
                    case 10000311:
                        return 'Muhtelif Arsa';
                    case 10000312:
                        return 'Okul (Eğitim Tesisi)';
                    case 10000313:
                        return 'Özel Kullanım';
                    case 10000314:
                        return 'Sit Alanı';
                    case 10000316:

                    case 10000317:
                        return 'Turizm İmarlı';
                    case 10000401:
                        return 'Ada - Toprak Parçası';
                    case 10000402:
                        return 'A-Lejantlı';
                    case 10000403:
                        return 'Enerji Depolama';
                    case 10000404:
                        return 'Sera';
                    case 10000405:
                        return 'Spor Alanı';
                    case 10000406:
                        return 'Turizm + Konut';
                    case 10000407:
                        return 'Turizm + Ticari';

                    case 99:
                    case 10000236:
                    case 10000400:
                        return 'list_other';

                    default:
                        return 'list_other';
                }
            };

            $rootScope.calculateDaysWithComp = function (comp) {
                let lastDate;
                if (comp.ListingActive) {
                    lastDate = new Date();
                } else {
                    lastDate = new Date(comp.LastActivityDate);
                }
                var end = moment(lastDate);
                var start = moment(comp.CreateDate);
                var duration = moment.duration(end.diff(start));
                var days = duration.asDays();
                return Math.ceil(days);
            };

            $rootScope.lastUpdateDate = function (comparable) {
                if (!comparable.LastActivityDate) {
                    return comparable.UpdateDate;
                }
                return comparable.UpdateDate > comparable.LastActivityDate
                    ? comparable.UpdateDate
                    : comparable.LastActivityDate;
            };

            var isTop = $window.hasAllowance;
            if (isTop) {
                $('body').css('padding-top', '0');
                $('#top-nav-bar').remove();
                $rootScope.isTop = true;
            }

            $rootScope.showOptIn = false;
            $rootScope.setDengagePermission = function (perm) {
                $rootScope.showOptIn = false;
                if (perm === 'granted')
                    dengage('showNativePrompt');
                else {
                    let now = new Date();

                    let item = {
                        value: perm,
                        expiry: now.getTime() + (60000 * 60 * 48),
                    };
                    $window.localStorage.setItem('webPushDeny', JSON.stringify(item));
                }
            };
            if ((window.location.host === 'www.endeksa.com' || $window.location.host === 'preprod.endeksa.com') && $window.location.href.indexOf('top=') === -1 && !window.isHeadless()) {
                var engageCheck = $interval(function () {
                    let itemStr = $window.localStorage.getItem('webPushDeny');
                    let requestPerm = false;

                    if (!itemStr) {
                        requestPerm = true;
                    }

                    if (!requestPerm) {
                        let item = JSON.parse(itemStr);
                        let now = new Date();

                        if (now.getTime() > item.expiry) {
                            $window.localStorage.removeItem('webPushDeny');
                            requestPerm = true;
                        }
                    }


                    if (typeof dengage !== 'undefined') {
                        dengage('initialize');
                        dengage('isPushNotificationsSupported', function (isSupported) {
                            if (isSupported && $('.cky-overlay').hasClass('cky-hide')) { //cookie modalı yoksa gösterelim
                                dengage('getNotificationPermission', function (permission) {
                                    if (requestPerm && permission === 'default') {
                                        $rootScope.showOptIn = true;
                                    }
                                });
                            }
                        });
                        $interval.cancel(engageCheck);
                    }
                }, 500);
            }

            // if (!$rootScope.ad && $rootScope.SignedIn && !isTop)
            //     $timeout(function () {
            //         if ($window.location.pathname.indexOf('payment') === -1 &&
            //             $window.location.pathname.indexOf('cozumler') === -1 &&
            //             $window.location.pathname.indexOf('urunler') === -1 &&
            //             $window.location.pathname.indexOf('register') === -1 &&
            //             $window.location.pathname.indexOf('signin') === -1 &&
            //             $window.location.pathname.indexOf('solutions') === -1 &&
            //             $window.location.pathname.indexOf('products') === -1) {
            //             try {
            //                 var remindDate = $window.userStorage.getItem('survey_date');
            //                 var a = moment();
            //                 var b = moment(remindDate);
            //                 var diff = a.diff(b, 'days');
            //                 var opened = ngDialog.getOpenDialogs();
            //                 var survey = $window.userStorage.getItem('survey');
            //                 if (!opened.length && $window.lang === 'tr' && !survey && (!remindDate || diff >= 1) && !$window.selectedLocation)
            //                     if (userSvc.info.SignedIn)
            //                         userSvc.getUserInfo().then(function (account) {
            //                             if (account && account.information.id.value) {
            //                                 var id = account.information.id.value;
            //                                 continueList(id);
            //                             }
            //                         }, function (err) {
            //                             deferred.reject(err);
            //                         });
            //                     else
            //                         continueList('');
            //             } catch (err) {
            //                 //ignored
            //             }
            //         }
            //     }, 20000);



            // var continueList = function (id) {
            //     var finger;
            //     var options = {
            //         excludes: {
            //             'enumerateDevices': true,
            //             'pixelRatio': true,
            //             'doNotTrack': true,
            //             'fontsFlash': true,
            //             'webgl': true,
            //             'webglVendorAndRenderer': true
            //         }
            //     };
            //     try {
            //         $window.Fingerprint2.get(options, function (components) {
            //             var values = components.map(function (component) { return component.value; });
            //             finger = $window.Fingerprint2.x64hash128(values.join(''), 31);
            //             pollAPI.get({ userid: id, userfinger: finger, lang: $window.lang }).$promise.then(function (result) {
            //                 var question = result.Questions[0];
            //                 var district = result.DistrictId;
            //                 if (question)
            //                     ngDialog.open({
            //                         templateUrl: 'app/shell/poll-question.html',
            //                         className: 'ng-dialog-bottom',
            //                         bodyClassName: '',
            //                         overlay: false,
            //                         closeByEscape: false,
            //                         showClose: false,
            //                         closeByNavigation: false,
            //                         disableAnimation: true,
            //                         closeByDocument: true,
            //                         controller: ['$scope', 'pollAPI', '$timeout', 'geoApi', 'yandexGeocode', function ($scope, pollAPI, $timeout, geoApi, yandexGeocode) {
            //                             $scope.useLocationPoll = function () {
            //                                 if (navigator.geolocation) {
            //                                     navigator.geolocation.getCurrentPosition(function (position) {
            //                                         if (position) {
            //                                             $window.selectedLocation = position.coords.longitude + ' ' + position.coords.latitude;
            //                                             $timeout(function () {
            //                                                 $scope.findDistrict();
            //                                             }, 100);
            //                                         }
            //                                     }, function () { }, {
            //                                         enableHighAccuracy: true,
            //                                         timeout: 5000,
            //                                         maximumAge: 0
            //                                     });
            //                                 }
            //                             };
            //                             $scope.address = "";
            //                             $scope.question = question.Question;
            //                             $scope.showDistrict = !district;
            //                             $scope.no = function () {
            //                                 if ($window.selectedLocation && $scope.showDistrict) {
            //                                     $scope.findDistrict();
            //                                 }

            //                                 pollAPI.post({ UserId: id, UserFinger: finger, Answer: false, QuestionId: question.QuestionId, DistrictId: district }).$promise.then(function () {

            //                                 });
            //                             };
            //                             $scope.remind = function () {
            //                                 $window.userStorage.setItem('survey_date', moment());
            //                             };
            //                             $scope.yes = function () {
            //                                 if ($window.selectedLocation && $scope.showDistrict) {
            //                                     $scope.findDistrict();
            //                                 }
            //                                 pollAPI.post({ UserId: id, UserFinger: finger, Answer: true, QuestionId: question.QuestionId, DistrictId: district }).$promise.then(function () {

            //                                 });
            //                             };

            //                             $scope.findDistrict = function () {
            //                                 if ($window.selectedLocation || $scope.address) {
            //                                     var lat, lng;
            //                                     if ($window.selectedLocation) {
            //                                         lat = +window.selectedLocation.split(' ')[1];
            //                                         lng = +window.selectedLocation.split(' ')[0];
            //                                     }
            //                                     yandexGeocode.geocodeAddress($scope.address, null, lat).then(function (location) {
            //                                         var geoAp = geoApi.get({ Lat: lat ? +lat : location.lat(), Long: lng ? +lng : location.lng(), Level: 3 });
            //                                         geoAp.$promise.then(function (resb) {
            //                                             district = resb.features[0].id;
            //                                             $scope.showDistrict = false;
            //                                         }, function (err) { console.log(err); });
            //                                     });
            //                                 }
            //                             };
            //                         }]
            //                     });
            //                 else {
            //                     $window.userStorage.setItem('survey', 1);
            //                 }
            //             });
            //         });
            //     } catch (err) {
            //         //ignored
            //     }
            // };

            // Currency conversion function - moved from controllers to $rootScope
            $rootScope.convertCurrency = function (value, sourceCurrency, targetCurrency) {
                value = value || 0;

                if (typeof sourceCurrency === 'number') {
                    sourceCurrency = $window.currencyIso(sourceCurrency);
                }

                if (typeof targetCurrency === 'number') {
                    targetCurrency = $window.currencyIso(targetCurrency);
                }

                if ($window.currencyRates) {
                    if (sourceCurrency === "TRY") {
                        if (targetCurrency === "USD")
                            value = value / $window.currencyRates.usd;
                        else if (targetCurrency === "EUR")
                            value = value / $window.currencyRates.eur;
                        else
                            value = value;
                    }
                    else if (sourceCurrency === "USD") {
                        if (targetCurrency === "TRY")
                            value = value * $window.currencyRates.usd;
                        else if (targetCurrency === "EUR")
                            value = value * $window.currencyRates.usd / $window.currencyRates.eur;
                        else
                            value = value;
                    }
                    else if (sourceCurrency === "EUR") {
                        if (targetCurrency === "TRY")
                            value = value * $window.currencyRates.eur;
                        else if (targetCurrency === "USD")
                            value = value * $window.currencyRates.eur / $window.currencyRates.usd;
                        else
                            value = value;
                    }
                }

                return Math.round(value);
            };
        }]);

})();
